/*  dev-build 236 — land a reload where the customer was (Ben, 28-09-2026).
    On a reload halfway down, phones painted the top of the page and then jumped down
    once the browser put the scroll back, which on a long page is after everything has
    loaded. This puts the position back as soon as the page is parsed, and again after
    load in case images below changed the height. It only acts on a reload of the same
    page, stops the moment the customer touches or scrolls, and hands scrolling back to
    the browser when the page is left, so Back and Forward behave as normal. */
(function () {
    try {
        var key = 'bbScroll:' + location.pathname + location.search;
        window.addEventListener('pagehide', function () {
            try {
                sessionStorage.setItem(key, String(Math.round(window.scrollY)));
                if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
            } catch (e) {}
        });
        var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if (!nav || nav.type !== 'reload') return;
        var y = parseInt(sessionStorage.getItem(key) || '0', 10);
        if (!(y > 0)) return;
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        var moved = false;
        ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (t) {
            window.addEventListener(t, function () { moved = true; }, { once: true, capture: true, passive: true });
        });
        var go = function () { if (!moved && Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go, { once: true });
        else go();
        window.addEventListener('load', function () { go(); setTimeout(go, 120); }, { once: true });
    } catch (e) {}
})();

// ── Format top bar dates e.g. "Fri 14 – Mon 17 Aug" ─────────────
function formatTopBarDates(startDate, endDate) {
    /*  Month names come from charged-nights.js now, not from the browser.
        toLocaleDateString('en-AU', {month:'short'}) returns "Sept" for September and
        three-letter forms for every other month, while pb-cart.js and two other files
        hard-coded "Sep" — one page, two spellings. See the note in charged-nights.js.

        Only the end date carries a month, which is the approved format:
        "Fri 14 - Mon 17 Aug".

        UTC parts, because the only caller passes dates already anchored at midday UTC,
        and reading local parts off a UTC-anchored date is how this whole class of
        one-day-out bug starts. */
    const D = window.DAYS_SHORT || ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const M = window.MONTHS_SHORT || ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                                      'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    const startStr = `${D[startDate.getUTCDay()]} ${startDate.getUTCDate()}`;
    const endStr = `${D[endDate.getUTCDay()]} ${endDate.getUTCDate()} ${M[endDate.getUTCMonth()]}`;

    return `${startStr} - ${endStr}`;
}

/* getTopBarFreeLabels removed — the shared computeNights() already returns freeLabels.

   The version that was here was the booking bar's own SEVENTH implementation of the
   closed-day rule, and it had three faults:

   1. IT COULD THROW. `closures.find(c => c.weekday.toLowerCase() === dayName)` had no
      null guard and no `!c.date` filter. A one-off dated closure carries
      `weekday: null`, so this threw a TypeError — order-dependent, because .find()
      short-circuits, so it only threw when the null-weekday record was reached before
      the day's own weekday matched. The throw happened inside updateTopBarTitle, so the
      bar's confirmed title silently stopped updating. Note that the copy in
      booking-calendar.js guarded this correctly with `!c.date && c.weekday?.` — the two
      copies did not even agree on their guards.

   2. NO ONE-OFF DATED CLOSURES. It only ever looked at recurring weekdays and holidays,
      so a closure like 24 Dec was correctly a free night in the price and produced no
      "you're not charged for..." label in the bar. The bar and the card disagreed in
      words while agreeing in numbers.

   3. THE DAYLIGHT-SAVING WALK. `new Date(start)` parses as UTC midnight and
      `current.setDate(current.getDate() + 1)` walks local time, so a range spanning the
      October or April change ran one extra iteration and could add a spurious label. */

/*  ── #193: THE COUNTDOWN FORMAT FOLLOWS THE MAGNITUDE ───────────────────────

    mm:ss was right at fifteen minutes. At two hours it renders "120:00", which is
    not a time anyone reads — and a seconds digit ticking for two hours is a moving
    object in the corner of every page for the whole window.

        >= 1h     1h 58m
        >= 10m    42m
        <  10m    4:32      seconds only when a second is worth watching

    FLOOR, NEVER ROUND. Math.round on a countdown rounds toward MORE time: 4:32
    would read "5 minutes". On a deadline that is not a rounding preference, it is a
    promise the clock cannot keep. Flooring also closes two thirty-second windows
    rounding opens — 3570-3599s rendering "60m", and 7170-7199s rendering "1h 60m".

    A countdown may understate. It may never overstate.                            */
function bbCutOffClock(s) {
    if (s >= 3600) {
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        return m ? h + 'h ' + m + 'm' : h + 'h';
    }
    if (s >= 600) return Math.floor(s / 60) + 'm';
    return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
}

/*  Three tiers on Ben's intervals. Every colour pair is already in booking-bar.css
    and already proven against its own ground there, so this returns a CLASS and
    never a colour — the stylesheet owns the values, and there is one place to
    change them. Red means CRITICAL, not unreachable. */
function bbCutOffTier(s) {
    if (s < 900) return 'is-urgent';
    if (s < 3600) return 'is-elevated';
    return '';
}

/*  Under ten minutes the label leaves, at the same point the seconds arrive. By
    then the figure is the message and the sentence around it is furniture — and it
    buys back exactly the width the seconds need, so the pill stays about one width
    throughout. */
function bbCutOffLabelFits(s) { return s >= 600; }

// ── Dispatch booking bar changed event ───────────────────────────
function dispatchBookingBarChanged(start, end, locationData) {
    const locationGid = locationData?.gid
        ? (String(locationData.gid).startsWith('gid://')
            ? locationData.gid
            : `gid://shopify/Metaobject/${locationData.gid}`)
        : null;

    document.dispatchEvent(new CustomEvent('bookingbar:changed', {
        detail: {
            locationGid,
            startDate: start,
            endDate:   end,
        }
    }));

    /* ── Persist the booking ────────────────────────────────────────────────
       This is the gap that made a date change in the global bar evaporate on the next
       page load. Only add-to-cart (pp-product.js) and the cart page (pb-cart.js) ever
       wrote the cart attributes, so the bar could tell every listener on the page and
       still leave nothing behind.

       Consequence beyond the lost dates: syncBarFromCart() below needs
       _pick_up_iso, _return_iso AND Location to restore anything. With no dates
       written, it returned early and the location was not restored either — which is
       why a location appeared to need reselecting. One cause, two symptoms.

       Skipped on the cart page: pb-cart.js already owns the write there and also
       re-prices the line items, which this must not duplicate.

       The write is idempotent, so the call from the page-load path at the bottom of
       this file is a no-op rather than a second write. */
    const onCartPage = window.location.pathname.indexOf('/cart') === 0;
    if (!onCartPage && start && end && locationData && typeof window.writeBookingAttributes === 'function') {
        window.writeBookingAttributes(start, end, locationData);
    }
}

/* ── Apply booking state to booking bar UI ───────────────────
   Called on cart page load to reflect cart bookings in
   the booking bar without user interaction.               */
function applyBookingToBar(locationGid, startDate, endDate) {
    // ── Find location data ─────────────────────────────────
    let locationData   = null;
    let locationHandle = null;
    if (window.locationMetaobjects) {
        const incomingId = String(locationGid).replace('gid://shopify/Metaobject/', '');
        const entry = Object.entries(window.locationMetaobjects).find(([, l]) =>
            String(l.gid).replace('gid://shopify/Metaobject/', '') === incomingId
        );
        if (entry) {
            locationHandle = entry[0];
            locationData   = entry[1];
        }
    }

    if (!locationData) return;

    // ── Update .bb-pickup-from ─────────────────────────────
    const pickupEl = document.querySelector('.bb-pickup-from');
    if (pickupEl) {
        pickupEl.textContent = locationData.suburb || locationData.name || '';
        pickupEl.classList.add('active');
    }

    // ── Update .bb-hire-dates ──────────────────────────────
    const hireDatesEl = document.querySelector('.bb-hire-dates');
    if (hireDatesEl) {
        const fmt = window.formatDate || (d => d);
        hireDatesEl.textContent = `${fmt(startDate)} - ${fmt(endDate)}`;
        hireDatesEl.classList.add('active');
    }

    if (typeof window.updateTopBarTitle === 'function' && locationData) {
        window.updateTopBarTitle(startDate, endDate, locationData);
    }

    // ── Update .bb-top-right-btn ───────────────────────────
    const editBtn = document.querySelector('.bb-top-right-btn');
    if (editBtn) editBtn.classList.add('active');

    // ── Update .bb-panel-location active state ────────────
    isProgrammaticLocationChange = true;
    document.querySelectorAll('.bb-panel-location').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.location === locationHandle);
    });
    isProgrammaticLocationChange = false;

    // ── Update calendar selection ──────────────────────────
    if (typeof window.updateCalendarSelection === 'function') {
        window.bookingDates = { start: startDate, end: endDate };
        window.updateCalendarSelection();
    }
}

/* ── Listen for bookingbar:changed on cart page ──────────────
   Applies the booking state to the bar UI when the
   cart page dispatches the event on load.               */
document.addEventListener('bookingbar:changed', function (e) {
    const { locationGid, startDate, endDate } = e.detail || {};
    if (!locationGid || !startDate || !endDate) return;
    applyBookingToBar(locationGid, startDate, endDate);
});

/*  ── #193: THE CONDENSED SUB-LINE ───────────────────────────────────────────

    The line is server-rendered in booking-bar.liquid, so this only has to keep it in
    step with changes made after load. It reads the SHARED source — the dates it is
    given and the location record — never the rendered text of the bar above it.
    Reading a sibling's textContent is how two parts of a page start disagreeing when
    only one of them updates.

    formatTopBarDates is the same function the bar's own title uses, which is why the
    two cannot drift and why the Liquid reproduces that exact format.                */
function updateSubLine(start, end, locationData) {
    const sub = document.querySelector('.bb-sub');
    if (!sub) return;

    const datesEl = sub.querySelector('.bb-sub-dates');
    const branchEl = sub.querySelector('.bb-sub-branch');
    const nightsEl = sub.querySelector('.bb-sub-nights');
    const editEl = sub.querySelector('.bb-sub-edit');
    const seps = sub.querySelectorAll('.bb-sub-sep');
    const dot = sub.querySelector('.bb-sub-dot');
    const cfg = window.bookingBarConfig || {};

    const has = !!(start && end && locationData);

    if (datesEl) {
        datesEl.textContent = has
            ? formatTopBarDates(new Date(toNoonUTC(start)), new Date(toNoonUTC(end)))
            : (cfg.subEmptyText || 'No dates yet');
        datesEl.classList.toggle('is-empty', !has);
    }
    if (branchEl) branchEl.textContent = has ? (locationData.suburb || locationData.name || '') : '';
    if (nightsEl && has) {
        /*  One owner for the night count. computeNights is the same walk the bar's
            title and the booking card use, so the line cannot claim a different
            number from the card underneath it. */
        const cn = computeNights(start, end, locationData);
        const n = cn.nightsCharged;
        /* 669: Holiday pricing wording ("3 nights inc. NYE") when the rule applies. */
        nightsEl.textContent = cn.priceRuleLabel || (n + ' ' + (n === 1 ? 'night' : 'nights'));
    } else if (nightsEl) {
        nightsEl.textContent = '';
    }
    if (editEl) editEl.textContent = has
        ? (cfg.subEditLabel || 'Edit')
        : (cfg.subAddLabel || 'Add dates');

    /*  Clear stale values as well as writing fresh ones (#92). The dot, the two
        separators and the two meta cells are the parts with nothing to say without a
        booking; the line itself stays, because the empty state is a prompt. */
    if (dot) dot.classList.toggle('hidden', !has);
    seps.forEach(s => s.classList.toggle('hidden', !has));
    if (branchEl) branchEl.classList.toggle('hidden', !has);
    if (nightsEl) nightsEl.classList.toggle('hidden', !has);

    window.bbSubState = { has: has, text: has ? datesEl && datesEl.textContent : '' };
    bbWriteTwoLines();
}
window.updateSubLine = updateSubLine;

/*  ── dev-build 343: THE TWO LINES — the header pill and the phone bar ────────────
    Ben, 10-10-2026, against Booking Header - Build Preview.dc.html:
      · the pill shows the LOCATION (Sydney, Melbourne), not the suburb;
      · with nothing set it reads the bar's own empty wording, "Add your hire dates"
        and "Choose a location", on two lines, not one cut-off sentence;
      · the phone bar on other pages reads the same as the pill: dates over location
        (Phone Bar Copy.dc.html, option C).
    One writer for those three places. The dates are the committed booking (what
    updateSubLine was last given); the location is the active one in the panel, which
    saves the moment it is picked. Only the hosted pill is touched: an older header
    with no slot keeps the 30px line exactly as updateSubLine writes it. */
function bbWriteTwoLines() {
    var st = window.bbSubState || { has: false, text: '' };
    var hb = document.querySelector('.booking-bar .bb-hbar');
    var cfg = window.bookingBarConfig || {};
    var emptyD = (hb && hb.getAttribute('data-empty-dates')) || cfg.emptyDatesText || '';
    var emptyL = (hb && hb.getAttribute('data-empty-loc')) || '';
    var act = document.querySelector('.bb-panel-location.active');
    var loc = act && (window.locationMetaobjects || {})[act.getAttribute('data-location')];
    var name = (loc && loc.name) || '';
    var dates = st.has ? st.text : emptyD;

    var sub = document.querySelector('.mm-pill-slot .bb-sub:not([data-bb-pill-copy])');
    if (sub) {
        var d = sub.querySelector('.bb-sub-dates');
        var b = sub.querySelector('.bb-sub-branch');
        if (d) { d.textContent = dates; d.classList.toggle('is-empty', !st.has); }
        if (b && (act || !b.textContent.trim())) { b.textContent = name || emptyL; b.classList.toggle('is-empty', !name); }
        if (b) b.classList.remove('hidden');
    }
    document.querySelectorAll('.bb-top-mobile-l1').forEach(function (e) {
        e.textContent = dates; e.classList.toggle('is-empty', !st.has);
    });
    document.querySelectorAll('.bb-panel-top-loc').forEach(function (e) {
        var t = e.querySelector('.bb-panel-top-loc-text');
        if (t) t.textContent = name ? (e.getAttribute('data-label') + ' ' + name) : '';
    });
    /*  Before the cart has been read back there is no active location yet, but the
        server already printed it. Leave the printed name alone until there is one. */
    document.querySelectorAll('.bb-top-mobile-l2').forEach(function (e) {
        if (!act && e.textContent.trim()) return;
        e.textContent = name || emptyL; e.classList.toggle('is-empty', !name);
    });
}
window.bbWriteTwoLines = bbWriteTwoLines;

// ── Update top bar confirmed title ───────────────────────────────
function updateTopBarTitle(start, end, locationData) {
    /* One call, one source. nightsCharged and freeLabels now come from the same walk, so
       the bar's number and the bar's reason can no longer disagree with each other or
       with the booking card. */
    /* 581: the hidden title this wrote is removed. The function stays because every
       restore and confirm routes the condensed line through it. */

    /*  One call site, so the condensed line cannot be updated in some paths and not
        others. Every restore and every confirm already routes through here. */
    updateSubLine(start, end, locationData);
}

let isProgrammaticLocationChange = false;

document.addEventListener('DOMContentLoaded', function () {

    // ─── Panel open/close ────────────────────────────────────────
    const bb_panel            = document.querySelector('.bb-panel');
    const bb_panel_close      = document.querySelector('.bb-panel-close');
    const bb_panel_footer_btn = document.querySelector('.bb-panel-footer-bottom-btn');
    const bb_top_right_btn    = document.querySelector('.bb-top-right-btn');
    const bb_footer_btn       = document.querySelector('.bb-panel-footer-btn-action');
    const bb_top_mobile       = document.querySelector('.bb-top-mobile');

    if (bb_top_right_btn) {
        bb_top_right_btn.addEventListener('click', function () {
            bb_panel.classList.remove('hidden');
        });
    }

    if (bb_top_mobile) {
        bb_top_mobile.addEventListener('click', function () {
            bb_panel.classList.remove('hidden');
        });
    }

    /*  ── CLOSING HAS TO UNDO WHAT OPENING DID ───────────────────────────────
        `bb-panel-open` was put on <body> when the panel opened and taken off
        nowhere, so it survived every close and everything after it. Nothing in the
        theme styled it, so it sat harmless — until 177 gave it a rule, at which
        point one visit to the picker permanently hid the condensed line.

        177's rule is gone; this closes the leak that made it dangerous. A class set
        on open and cleared nowhere is a bug waiting for its first consumer, and it
        found one. Both close paths clear it. */
    function bbClosePanel() {
        if (bb_panel) bb_panel.classList.add('hidden');
        document.body.classList.remove('bb-panel-open');
        $('.bb-p2b').removeClass('is-editing');   // 212 — reopening shows the calendar, not the cards

        /*  ── CLOSING HALFWAY THROUGH A RE-PICK KEEPS THE OLD DATES — dev-build 188 ──
            Picking a new pick-up day drops the return day, and the bar redraws as
            "Add your hire dates" straight away. Closing there left the bar empty while
            the cart still held the old booking, because nothing was ever saved — the
            half-pick only lived in the panel. So the bar and the cart disagreed.

            Only a HALF pick is undone. A complete new pair left unconfirmed behaves as
            it always has, and a deliberate clear (clearBookingDates) forgets the old
            pair, so a cut-off or closed-day clear is never undone by closing. */
        /*  dev-build 212 — also when BOTH dates are empty. 2b's Start box empties the
            pair to re-pick, which is the same half-finished state one step earlier.
            A deliberate clear still nulls bbCommittedDates, so it is never undone. */
        var bd = window.bookingDates || {};
        var kept = window.bbCommittedDates;
        if (!bd.end && kept && kept.start && kept.end) {
            window.bookingDates = { start: kept.start, end: kept.end };
            $('.bb-panel-content-cap-note').addClass('hidden');
            if (typeof window.renderCalendar === 'function') window.renderCalendar();
            else if (typeof window.updateCalendarSelection === 'function') window.updateCalendarSelection();
        }
    }

    /*  ── CLOSING SAVES — dev-build 193 (Ben, 25-09-2026) ─────────────────────────
        The branch saves the moment it is clicked, so closing the panel any way — the
        ×, "Use these dates", or a click outside — saves a complete pair of dates too.
        Otherwise the bar shows one booking and the cart holds another, which is the
        mismatch found in 191 testing.

        A HALF pick is still undone by bbClosePanel (dev-build 188) before this runs,
        so closing mid re-pick keeps the old dates. Nothing is written unless the
        booking actually changed since the panel was opened.                          */
    function bbBookingKey() {
        const d = window.bookingDates || {};
        const loc = activeLocationData();
        return [d.start || '', d.end || '', loc ? loc.name : ''].join('|');
    }
    window.bbTakeSnapshot = function () {
        if (window.bbOpenSnapshot == null) window.bbOpenSnapshot = bbBookingKey();
    };

    /*  ── THE BAR'S GEAR LIST, FRESH EVERY TIME IT OPENS — dev-build 194 ─────────
        window.bookingBarItemData is printed by booking-bar.liquid at page load and was
        only re-read after removing a line from inside the bar. Gear added from a
        product page or the cart drawer was missing until a reload, so the calendar had
        nothing to paint red for it. Opening the panel re-reads /cart.js and repaints.
        Lines already known keep their server-worked fields (nights, availability);
        new lines get the same defaults the remove path uses.                        */
    var bbRefreshSeq = 0;
    var bbCartDirty  = false;
    var bbLastRead   = Date.now();   // the page-load data counts as a read
    function bbRefreshItems() {
        var seq = ++bbRefreshSeq;
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                /*  dev-build 195. A slower, older answer must not overwrite a newer one —
                    two refreshes fired close together can resolve out of order. */
                if (seq !== bbRefreshSeq) return;
                bbCartDirty = false;
                bbLastRead  = Date.now();

                /*  dev-build 197 — the header "Your booking" count, from the same read.
                    It was only rewritten by some cart paths, so removing from the drawer
                    or the cart page left it stale until a reload. Every cart write on the
                    page now ends here. UNITS, cart.item_count — the same figure
                    header-actions.liquid prints, never cart.items.length (lines). */
                var bbCount = String(cart.item_count || 0);
                document.querySelectorAll('[data-cart-count], .mm-booking__count').forEach(function (el) {
                    if (el.textContent.trim() !== bbCount) el.textContent = bbCount;
                });
                window.bookingBarItemData = window.bookingBarItemData || {};
                const old = window.bookingBarItemData.items || [];
                const sig = list => JSON.stringify((list || []).map(i => [i.id, i.product_id, i.variant_id, i.quantity]));
                const before = sig(old);
                window.bookingBarItemData.items = (cart.items || []).map(function (item) {
                    const o = old.find(function (i) { return i.id === item.id; }) || {};
                    return Object.assign({}, o, {
                        id:         item.id,
                        title:      item.product_title,
                        url:        '/products/' + item.handle,
                        product_id: item.product_id,
                        variant_id: item.variant_id,
                        options:    (item.options_with_values || []).map(function (x) { return x.value; }),
                        quantity:   item.quantity,
                        key:        item.key,
                        properties: o.properties || {
                            '_variant_label': (item.properties && item.properties['_variant_label']) || '',
                            'Cable kit':      (item.properties && item.properties['Cable kit']) || ''
                        },
                        nights:       o.nights       || { total: 0, charged: 0, free: 0 },
                        hire_period:  o.hire_period  || { unpriceable: true },
                        hire_periods: o.hire_periods || [],
                        availability: o.availability || { blocked_ranges: '', product_messages: '', turnaround_nights: 0 },
                        availability_by_location: o.availability_by_location || {}
                    });
                });
                /*  dev-build 198 — repaint only when the gear actually changed. A no-op
                    repaint mid-click is what lost Ben's 21 Oct return. */
                if (sig(window.bookingBarItemData.items) !== before &&
                    typeof window.renderCalendar === 'function') window.renderCalendar();
            })
            .catch(function () {});
    }
    window.bbRefreshItems = bbRefreshItems;

    /*  ── WHEN THE BAR RE-READS THE CART — dev-build 195 (Ben: "always accurate") ──
        194 refreshed only in the delegated opener, and "Check availability"
        (.bb-top-right-btn) has its own opener that never reached it. So instead of
        hooking every button that can open the panel, watch the panel itself: any time
        it goes from hidden to shown, re-read. Also on every cart event this theme
        fires, because an add can still be in flight when the panel opens — the later
        event catches what the first read missed. Branch and date changes call it from
        their own handlers.                                                          */
    /*  ── FAST: READ WHEN THE CART CHANGES, NOT WHEN THE PANEL OPENS — dev-build 196 ──
        195 re-read /cart.js on every open and every date click, so the customer
        waited a round trip each time (Ben: "it works, but it's slow"). Now every cart
        write on this page — any POST to /cart/add, /cart/change, /cart/update or
        /cart/clear, by fetch or jQuery — triggers the read the moment it lands. By the
        time the panel opens the answer is already here, so opening costs nothing.

        The panel still re-reads on open if a write was seen that has not been read
        yet, or if the last read is over a minute old (a change made in another tab
        cannot be seen any other way). Accurate first, fast second.               */
    var BB_CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var bbQueued = null;
    /*  dev-build 207 — never read the cart halfway through the cart page's own
        re-price (window.pbCartBusy, pb-cart.js). Wait for it to finish, then read
        once. While waiting, the booked-out list shows the updating state rather than
        a half-true answer (Ben: the skeleton for anything that updates). The 15s cap
        is a safety net for a re-price that errors without clearing its flag.        */
    var bbBusySince = 0;
    function bbCartWritten() {
        bbCartDirty = true;
        clearTimeout(bbQueued);
        if (window.pbCartBusy === true) {
            if (!bbBusySince) bbBusySince = Date.now();
            if (Date.now() - bbBusySince < 15000) {
                var list = document.querySelector('.bb-out-list');
                if (list) list.classList.add('is-updating');
                bbQueued = setTimeout(bbCartWritten, 150);
                return;
            }
        }
        bbBusySince = 0;
        bbQueued = setTimeout(function () {
            var done = function () {
                var list = document.querySelector('.bb-out-list');
                if (list) list.classList.remove('is-updating');
            };
            var p = bbRefreshItems();
            if (p && typeof p.then === 'function') p.then(done, done); else done();
        }, 40);
    }
    function bbRefreshIfStale() {
        if (bbCartDirty || Date.now() - bbLastRead > 60000) bbRefreshItems();
    }
    window.bbRefreshIfStale = bbRefreshIfStale;

    if (window.fetch && !window.fetch.__bbWrapped) {
        var bbFetch = window.fetch;
        window.fetch = function (input, init) {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
            var p = bbFetch.apply(this, arguments);
            if (method === 'POST' && BB_CART_WRITE.test(url)) {
                p.then(bbCartWritten, bbCartWritten);
            }
            return p;
        };
        window.fetch.__bbWrapped = true;
    }
    if (window.jQuery) {
        jQuery(document).ajaxComplete(function (ev, xhr, opts) {
            if (opts && String(opts.type || opts.method || '').toUpperCase() === 'POST' && BB_CART_WRITE.test(opts.url || '')) bbCartWritten();
        });
    }

    if (bb_panel && 'MutationObserver' in window) {
        var bbWasHidden = bb_panel.classList.contains('hidden');
        new MutationObserver(function () {
            var hidden = bb_panel.classList.contains('hidden');
            if (bbWasHidden && !hidden) {
                bbRefreshIfStale();
                /*  211 — every way of opening the panel takes the snapshot, not only
                    the delegated opener. */
                window.bbOpenSnapshot = null;
                window.bbTakeSnapshot();
                $('.bb-p2b').removeClass('is-editing');   // 212
            }
            bbWasHidden = hidden;
        }).observe(bb_panel, { attributes: true, attributeFilter: ['class'] });
    }
    ['pbcart:updated', 'bookingrow:updated', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
        document.addEventListener(ev, bbCartWritten);
    });

    /*  ── A CONFLICT IS NEVER SAVED — dev-build 209 (Ben, 26-09-2026) ─────────────
        Dates that were fine at one branch can clash at another: gear booked out there,
        or the pick-up or return day closed (runCutOffGuard then clears the dates).
        While that is so, nothing is written and clicking outside does not close the
        panel. The customer fixes it, or presses Close / × — which puts the saved
        booking back, branch and dates, rather than leaving the bar showing a booking
        the cart does not hold.                                                      */
    function bbParseKey(k) {
        const p = String(k || '').split('|');
        return { start: p[0] || null, end: p[1] || null, loc: p[2] || '' };
    }
    function bbInConflict() {
        const d = window.bookingDates || {};
        if (d.start && d.end) {
            return typeof bbOutLines === 'function' && bbOutLines(d.start, d.end).length > 0;
        }
        /*  dev-build 210 — no complete pair is never a clash. A branch switch that would
            clash now clears the dates and says why (bbClearOnBranchClash), the same as
            a closed day, so there is nothing left in conflict to hold the panel open. */
        return false;
    }
    window.bbInConflict = bbInConflict;

    /*  dev-build 211 — the "dates were cleared" note is about the dates that went.
        Once a complete new pair is chosen it is no longer true, so it goes. */
    document.addEventListener('click', function (ev) {
        if (!ev.target.closest || !ev.target.closest('.bb-calendar-day')) return;
        setTimeout(function () {
            const d = window.bookingDates || {};
            if (d.start && d.end && typeof hideClearedNote === 'function') hideClearedNote();
        }, 0);
    });

    /*  ── BRANCH SWITCH INTO A BLACKOUT — dev-build 210 (Ben, 26-09-2026) ───────────
        Same remedy as a closed day (runCutOffGuard onSwitch): the dates go, and the
        amber note says why. Replaces 209's "keep the clash, block the exit", which Ben
        swapped for this. Runs after applyLocationSelection, so a closed day that has
        already cleared the dates wins and keeps its own note.                       */
    function bbClearOnBranchClash() {
        const d = window.bookingDates || {};
        if (!d.start || !d.end || typeof bbOutLines !== 'function') return;
        const lines = bbOutLines(d.start, d.end);
        if (!lines.length) return;
        const names = [...new Set(lines.map(l => l.title))];
        const loc = activeLocationData();
        const where = (loc && (loc.suburb || loc.name)) || 'this branch';
        const who = names.length === 1 ? names[0] + ' is' : names.length + ' items are';
        clearBookingDates();
        const note = document.querySelector('.bb-cleared-note');
        if (note) {
            const body = note.querySelector('.bb-cleared-note-text') || note;
            body.textContent = 'Your dates were cleared because ' + who + ' booked out at ' + where +
                ' on those dates. Pick dates that work for this branch.';
            note.classList.remove('hidden');
        }
        if (typeof window.renderCalendar === 'function') window.renderCalendar();
    }
    function bbRestoreSaved() {
        const saved = bbParseKey(window.bbOpenSnapshot);
        if (!saved.loc) return;
        const handle = typeof locationHandleFromName === 'function' ? locationHandleFromName(saved.loc) : null;
        if (handle) applyLocationSelection(handle);
        window.bookingDates = { start: saved.start, end: saved.end };
        const loc = activeLocationData();
        if (saved.start && saved.end && loc) updateTopBarTitle(saved.start, saved.end, loc);
        if (typeof window.renderCalendar === 'function') window.renderCalendar();
    }

    function bbCommitAndClose(force) {
        if (bbInConflict()) {
            bbRestoreSaved();
            bbClosePanel();
            window.bbOpenSnapshot = null;
            return;
        }
        bbClosePanel();
        const start = window.bookingDates?.start;
        const end   = window.bookingDates?.end;
        const locationData = activeLocationData();
        const key = bbBookingKey();
        /*  dev-build 211 — no snapshot means the panel was opened by a path that never
            took one (the cart's own "Pick dates" / edit buttons), and 193 then treated
            the change as "nothing changed" and saved nothing: new dates, old prices.
            Unknown now counts as changed. The save is safe to repeat — pb-cart.js and
            writeBookingAttributes only write what actually differs.                 */
        const changed = window.bbOpenSnapshot == null || key !== window.bbOpenSnapshot;
        window.bbOpenSnapshot = null;
        if (!(start && end && locationData)) return;
        if (!force && !changed) return;
        updateTopBarTitle(start, end, locationData);
        dispatchBookingBarChanged(start, end, locationData);
    }

    /*  The branch, saved on click. With dates, it is the same save as "Use these
        dates" so nights and hours are re-worked for the new branch's closed days (a
        date that is illegal there has already been cleared by runCutOffGuard). With
        no dates, only the branch is written. */
    function bbSaveBranch() {
        const loc = activeLocationData();
        if (!loc) return;
        if (bbInConflict()) return;   // 209 — see "A CONFLICT IS NEVER SAVED"
        const start = window.bookingDates?.start;
        const end   = window.bookingDates?.end;
        if (start && end) {
            updateTopBarTitle(start, end, loc);
            dispatchBookingBarChanged(start, end, loc);
            window.bbOpenSnapshot = bbBookingKey();
            return;
        }
        if (typeof window.writeCartAttributes !== 'function') return;
        const pending = window.bbClearWrite || Promise.resolve();
        window.bbClearWrite = null;
        pending.then(function () {
            return window.writeCartAttributes({ 'Location': loc.name || '', 'Location suburb': loc.suburb || '' });
        })
            .then(function (wrote) {
                if (!wrote) return;
                if (document.querySelector('.pb-cart') && window.BookingRow &&
                    typeof window.BookingRow.refreshSections === 'function') {
                    window.BookingRow.refreshSections();
                }
            })
            .catch(function () {});
    }

    if (bb_panel_close) {
        bb_panel_close.addEventListener('click', function () { bbCommitAndClose(false); });
    }

    if (bb_panel_footer_btn) {
        bb_panel_footer_btn.addEventListener('click', function () {
            if (!this.classList.contains('active')) return;
            bbCommitAndClose(true);
        });
    }

    /*  Click outside closes — once a branch is chosen (Ben: "once a selection is
        made"). Before that the × is the only way out, so the choice stays conscious.
        Mobile's panel is full-screen, so there is no outside to click. Captured on
        mousedown so a click that starts outside and ends on a control still counts. */
    document.addEventListener('mousedown', function (ev) {
        if (!bb_panel || bb_panel.classList.contains('hidden')) return;
        if (!document.querySelector('.bb-panel-location.active')) return;
        const t = ev.target;
        /*  215 — "inside" means the white card, not the whole .bb-panel. 213 centred
            the card at 1120px, so its side gutters are .bb-panel too, and a click there
            was counted as inside: the panel stopped closing on outside clicks. */
        const card = bb_panel.querySelector('.bb-panel-inner') || bb_panel;
        if (!t || card.contains(t)) return;
        if (t.closest && t.closest('.bb-top-btn, .bb-top-mobile, .bb-sub-edit, .mm-pill-slot, .bb-hbar, .pp-booking-card-btn, .pp-booking-card-edit-btn, .bb-cutoff-modal, .bb-cleared-note')) return;
        if (bbInConflict()) return;   // 209 — a clash keeps the panel open
        /*  341 — THE CLICK THAT CLOSES THE PANEL DOES NOTHING ELSE. The panel closes on
            mousedown, so by the time the button comes up the dim has gone and the click
            lands on whatever is underneath: a product link, or the bar's own "Hire dates"
            button, which opened the panel again straight away. The one click that
            follows is swallowed. Not in the header, where a click on the menu should
            still work. */
        if (!(t.closest && t.closest('.header-section'))) {
            const swallow = function (e) { e.preventDefault(); e.stopPropagation(); };
            document.addEventListener('click', swallow, { capture: true, once: true });
            setTimeout(function () { document.removeEventListener('click', swallow, true); }, 500);
        }
        bbCommitAndClose(false);
    }, true);

    /*  341 — Esc closes the panel, as in the approved preview. Same rules as a click
        outside: only once a location is chosen, and not during a clash. */
    document.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Escape' || !bb_panel || bb_panel.classList.contains('hidden')) return;
        if (!document.querySelector('.bb-panel-location.active')) return;
        if (bbInConflict()) return;
        bbCommitAndClose(false);
    });

    /* ── SELECTING A LOCATION — the one routine ──────────────────────────────────
       Everything that must be true once a location is chosen. Call this; never set
       any of it piecemeal.

       This used to live inline in the click handler below, which meant it only ever
       ran when a HUMAN clicked. Restoring a booking from the cart on page load applied
       the .active class and nothing else, so:

         · window.selectedLocation stayed undefined, and booking-calendar.js reads it
           to find closures — so no closed day was greyed on any restored booking;
         · "Choose a pick-up location first" stayed on screen underneath a location
           that was visibly already selected;
         · the legend kept its no-location wording, "Closed days depend on the
           location — pick one to see them".

       The page looked selected and behaved unselected. One routine, three callers:
       the click handler, and both restore paths in syncBarFromCart. */
    function applyLocationSelection(locationHandle) {
        const data = window.locationMetaobjects?.[locationHandle];
        if (!data) {
            console.warn('No location data found for:', locationHandle);
            return false;
        }

        /*  #85 — a note from a previous switch must not survive this one. Cleared
            before anything else so it cannot be left asserting something about the
            location the customer has just moved away from. */
        hideClearedNote();

        window.selectedLocation = data;

        $('.bb-panel-location').removeClass('active');
        $('.bb-panel-location[data-location="' + locationHandle + '"]').addClass('active');

        $('.bb-pickup-from').html(data.suburb).addClass('active');
        /*  dev-build 212 — the breakdown, the "choose a location first" line and the
            legend's per-branch wording are gone from the markup (2b). */

        if (typeof window.renderCalendar === 'function') {
            window.renderCalendar();
        }

        /*  #85 — THE RE-VALIDATION THAT WAS MISSING.

            This function re-rendered the calendar for the new location but never
            re-tested the dates already chosen against it. So a date legal at Sydney
            survived a switch to Melbourne where it was not: a 1:05pm pick-up today,
            with Melbourne cutting off at 1pm.

            The hole was never only about the cut-off. Every per-location fact had it —
            a holiday at one location and not the other, a Special Trading Date, a
            closed weekday, a delivery blackout. One validator covers all of them,
            which is why this is a single call and not a list of checks.

            `true` selects the clear-and-tell remedy rather than the modal. See the
            block comment above runCutOffGuard for why the two differ. */
        runCutOffGuard(true);

        bbWriteTwoLines();   // 343: the location line follows the pick at once
        return true;
    }

    /* Find a location's handle from the display NAME held in the cart attributes.
       Matching on a display name is fragile — renaming a location in the admin breaks
       the join and the customer silently loses their selection. Storing the handle or
       GID in the attributes instead is an agreed change, tracked separately. */
    function locationHandleFromName(name) {
        const entry = Object.entries(window.locationMetaobjects || {}).find(
            ([, l]) => (l.name || '') === name
        );
        return entry ? entry[0] : null;
    }

    // ─── Location active ─────────────────────────────────────────
    $(document).on('click', '.bb-panel-location', function () {
        if (isProgrammaticLocationChange) return;
        window.bbTakeSnapshot();
        $('.bb-p2b').removeClass('is-editing');   // 212 — picking folds the cards again
        if (!applyLocationSelection($(this).data('location'))) return;
        bbClearOnBranchClash();
        bbPanelBookingFooter();
        bbSaveBranch();
        bbRefreshIfStale();
    });

    // ─── Breakdown show/hide ─────────────────────────────────────
    if (bb_footer_btn) {
        bb_footer_btn.addEventListener('click', function () {
            const footerContent = document.querySelector('.bb-panel-footer-content');
            if (!footerContent || footerContent.innerHTML.trim() === '') return;

            this.querySelectorAll('.bb-panel-footer-btn-child').forEach(function (child) {
                child.classList.toggle('hidden');
            });

            document.querySelector('.bb-panel-footer-btn-icon').classList.toggle('active');
            footerContent.classList.toggle('hidden');
        });
    }

    /*  ── 2b: CHANGE, AND THE START / RETURN BOXES — dev-build 212 ─────────────────
        Change unfolds the branch cards (.is-editing; picking a branch or closing the
        panel folds them again). The branch is not changed until a card is picked.

        Start empties the pair and Return empties the return, both in the panel only —
        nothing is written. Closing without finishing puts the saved pair back
        (bbClosePanel, 188/212), and a finished new pair saves on close as always.
        The breakdown's own Remove handler that stood here went with the breakdown;
        booked-out gear is removed from the list in booking-calendar.js (bbRemoveLines). */
    $(document).on('click', '.bb-p2b-change', function () {
        $('.bb-p2b').addClass('is-editing');
    });
    $(document).on('click', '.bb-p2b-step', function () {
        const d = window.bookingDates || {};
        if (window.bbTakeSnapshot) window.bbTakeSnapshot();
        if (this.getAttribute('data-step') === 'start') {
            if (!d.start && !d.end) return;
            window.bookingDates = { start: null, end: null };
        } else {
            if (!d.start || !d.end) return;
            window.bookingDates = { start: d.start, end: null };
        }
        $('.bb-panel-content-cap-note').addClass('hidden');
        if (typeof window.renderCalendar === 'function') window.renderCalendar();
    });

    // ─── Fire on page load if dates already set ──────────────────
    setTimeout(function () {
        const start          = window.bookingDates?.start;
        const end            = window.bookingDates?.end;
        const activeLocation = $('.bb-panel-location.active').data('location');
        const locationData   = window.locationMetaobjects?.[activeLocation];

        if (start && end && locationData) {
            updateTopBarTitle(start, end, locationData);
            dispatchBookingBarChanged(start, end, locationData);
        }
    }, 500);


    // ── Sync booking bar from cart attributes on page load ────────
    /* ═══ #84 / #85: THE CUT-OFF GUARD ═══════════════════════════════════════════

       Approved design: Cutoff Urgency.dc.html, states 6a, 6b, 6d.

       One question — is this booking still bookable — asked of one validator,
       window.validateBookingDates() in charged-nights.js. This file only decides what
       to DO about the answer, and it does two different things depending on where the
       customer is standing:

         location switch   CLEAR the dates. The customer just acted, the calendar is
                           open in front of them, re-picking is one tap.
         page load / timer  KEEP the dates and show the modal. A customer arriving cold
                           would otherwise lose a choice they made earlier without ever
                           being told why.

       Deliberately opposite remedies from the same verdict. If that ever gets
       "tidied" into one behaviour, read this paragraph first.

       WHY IT LIVES IN booking-bar.js and not pb-cart.js: the decision on 11-09-2026 was
       that a stale same-day booking is surfaced EVERYWHERE. There is no sense letting
       somebody keep adding gear for a day that has closed only to find out at the
       checkout. The bar is the only thing on every page.

       THE CLOCK. Every tick re-derives the remaining time from the store clock via
       secondsToCutOff() rather than decrementing a counter. A laptop that sleeps through
       the cut-off wakes up and gets the truth; a decrementing counter would still be
       showing four minutes left. The interval is also the thing that turns the warning
       into the modal when it reaches zero, so a customer who sat on the page through the
       cut-off is told, rather than finding out at the checkout.
    */
    var cutOffTimer = null;
    var cutOffModalShown = false;

    /*  #193 — the dismissal key that stood here is gone with the warning it
        dismissed. Nothing writes it and nothing reads it now; it is removed rather
        than left declared, because a dead constant is the next thing someone wires
        back in by accident. Any value already in a visitor's sessionStorage simply
        expires with their session and is never consulted again.  */

    function cutOffCopy(key, fallback) {
        return (window.bookingBarConfig && window.bookingBarConfig[key]) || fallback;
    }

    function activeLocationData() {
        var handle = $('.bb-panel-location.active').data('location');
        return (window.locationMetaobjects || {})[handle] || window.selectedLocation || null;
    }

    function fillTemplate(tpl, vals) {
        return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) {
            return vals[k] != null && vals[k] !== '' ? vals[k] : m;
        }).replace(/\s*\{\w+\}\s*/g, ' ').replace(/\s+([.,—])/g, '$1').replace(/\s{2,}/g, ' ').trim();
        /* 360: anything still in braces is removed rather than shown to a customer. */
    }

    /*  ── #193: THE PILL REPLACED THE WARNING ────────────────────────────────

        showCutOffBanner / hideCutOffBanner stood here and wrote into the expanded
        amber warning and its dismissed pill. Both are retired with the markup.

        WHAT WENT WITH THEM, deliberately:

          · the dismiss and expand pair. There is nothing left to dismiss — the pill
            IS the compressed form, it is 30px inside a line that is on screen
            anyway, and a dismiss control on it would cost more width than it saves.
          · the mm:ss format, for the reason given at bbCutOffClock.
          · the pulsing dot. See booking-bar.css.

        WHAT SURVIVED, and must: showing the pill re-arms the modal. cutOffModalShown
        stops the modal reappearing over a customer who has already answered it, and
        as a once-per-page-load flag that is too coarse — load with stale dates so the
        modal fires, clear them, pick today again, sit past the cut-off, and nothing
        happens. Reaching the pill means the booking became valid again, so any later
        failure is a NEW event rather than the one already answered.                */
    /*  359 — THE PHONE STRIP (Ben, 11-10-2026, Same-Day Cut-off Header Design option C).
        Inside the phone pill there is room for neither the sentence nor a tap target,
        so on phones and tablets, while the pill is in the header, the countdown is a
        32px strip under the header instead. Built once, filled by the same tick. */
    /*  The booking's dates as YYYY-MM-DD, whatever form bookingDates holds them in. */
    function bbIsoDay(v) {
        if (!v) return '';
        if (typeof window.civilDate === 'function') { try { return window.civilDate(v).ymd; } catch (e) {} }
        return String(v).slice(0, 10);
    }
    window.bbIsoDay = bbIsoDay;

    function bbCutOffStrip() {
        var s = document.querySelector('.bb-cutoff-strip');
        if (s) return s;
        /*  362 (Ben, 11-10-2026): it hung off the header with position:absolute, so it
            left a hairline gap content showed through, and it covered the breadcrumbs.
            It is now the last child of the sticky header SECTION, in the flow: the
            header grows by the strip's height, sticks as one piece, and pushes the
            page down instead of covering it. */
        var th = document.querySelector('theme-header') || document.querySelector('.header');
        var hdr = (th && th.closest('.shopify-section')) || th;
        if (!hdr) return null;
        /*  361 (Ben, 11-10-2026, design 2a): the strip says everything, so it is not a
            button and opens nothing. The box is only for after the cut-off. */
        s = document.createElement('div');
        s.className = 'bb-cutoff-strip hidden';
        s.setAttribute('role', 'status');
        s.innerHTML = '<span class="bb-cutoff-strip-dot" aria-hidden="true"></span><span class="bb-cutoff-strip-text"></span><strong class="bb-cutoff-strip-value"></strong><span class="bb-cutoff-strip-left"></span>';
        hdr.appendChild(s);
        return s;
    }

    /*  359 — the warning box opens by itself ONCE PER BOOKING, the first time the
        countdown appears (Ben, 11-10-2026). A booking is its branch and dates; change
        any of them and it counts as new. The chip and strip stay tappable after. */
    function bbCutOffWarnKey(loc) {
        var d = window.bookingDates || {};
        return 'bbCutWarn:' + ((loc && (loc.gid || loc.name)) || '') + '|' + bbIsoDay(d.start) + '|' + bbIsoDay(d.end);
    }

    function hideCutOffPill() {
        var strip = document.querySelector('.bb-cutoff-strip');
        if (strip) strip.classList.add('hidden');
        document.documentElement.classList.remove('bb-countdown-on');
        var hit = document.querySelector('.bb-cutoff-pill-hit');
        if (hit) hit.classList.add('hidden');
        var sub = document.querySelector('.bb-sub');
        if (sub) sub.classList.remove('has-countdown');
    }

    function showCutOffPill(secondsLeft, locationData) {
        var hit = document.querySelector('.bb-cutoff-pill-hit');
        if (!hit) return;

        cutOffModalShown = false;

        var pill = hit.querySelector('.bb-cutoff-pill');
        var label = hit.querySelector('.bb-cutoff-pill-label');
        var value = hit.querySelector('.bb-cutoff-pill-value');
        var clock = bbCutOffClock(secondsLeft);

        if (value) value.textContent = clock;
        if (label) label.classList.toggle('hidden', !bbCutOffLabelFits(secondsLeft));
        if (pill) {
            pill.classList.remove('is-elevated', 'is-urgent');
            var tier = bbCutOffTier(secondsLeft);
            if (tier) pill.classList.add(tier);
        }

        /*  The accessible name has to carry what the label drops. On mobile and under
            ten minutes the pill is a bare figure, and a button reading "42m" tells a
            screen-reader user nothing about what is closing. */
        var words = (window.bookingBarConfig && window.bookingBarConfig.cutOffPillText) ||
            'Same-day bookings close in';
        hit.setAttribute('aria-label', words + ' ' + clock);

        /*  The 44px target needs the line to be 44px on mobile, and only while the
            countdown is running — the rest of the day the line is 30. */
        var sub = document.querySelector('.bb-sub');
        if (sub) sub.classList.add('has-countdown');

        hit.classList.remove('hidden');

        var strip = bbCutOffStrip();
        if (strip) {
            var st = strip.querySelector('.bb-cutoff-strip-text');
            var sv = strip.querySelector('.bb-cutoff-strip-value');
            var sl = strip.querySelector('.bb-cutoff-strip-left');
            /*  361: the full sentence and a clock that counts every second.
                "Same-day pick-ups from Melbourne close at 3pm · 38:12 left". */
            var cutAt = typeof window.cutOffLabel === 'function' ? window.cutOffLabel(locationData, window.bookingBarConfig?.storeTimeZone) : '';
            /*  362: test mode on a closed day has no real cut-off time to name. */
            if (!cutAt && bbCutOffTest()) cutAt = '3pm';
            var narrow = window.innerWidth <= 420;
            var sentence = !cutAt
                ? fillTemplate(cutOffCopy('cutOffStripTextNoTime', 'Same-day pick-ups from {location} close soon'), { location: (locationData && locationData.name) || '' })
                : fillTemplate(narrow
                    ? cutOffCopy('cutOffStripTextShort', 'Same-day pick-ups close at {time}')
                    : cutOffCopy('cutOffStripText', 'Same-day pick-ups from {location} close at {time}'),
                { location: (locationData && locationData.name) || '', time: cutAt });
            var sH = Math.floor(secondsLeft / 3600), sM = Math.floor((secondsLeft % 3600) / 60), sS = secondsLeft % 60;
            var pad = function (n) { return (n < 10 ? '0' : '') + n; };
            var live = sH > 0 ? sH + ':' + pad(sM) + ':' + pad(sS) : sM + ':' + pad(sS);
            if (st) st.textContent = sentence + ' ·';
            if (sv) sv.textContent = live;
            if (sl) sl.textContent = cutOffCopy('cutOffStripLeft', 'left');
            words = sentence; clock = live;
            strip.classList.remove('is-elevated', 'is-urgent');
            var stier = bbCutOffTier(secondsLeft);
            if (stier) strip.classList.add(stier);
            strip.setAttribute('aria-label', words + ' ' + clock);
            strip.classList.remove('hidden');
        }
        document.documentElement.classList.add('bb-countdown-on');

        /*  361 (Ben, 11-10-2026): no warning box before the cut-off. The strip carries
            it; the box is only for forcing a date change after the cut-off. */

        /*  The modal echoes the pill that opened it, so if it is open while the clock
            ticks it must tick too. Same string, same format: the pair should not
            disagree about the number even in format. */
        var openModal = document.querySelector('.bb-cutoff-modal:not(.hidden)');
        if (openModal && openModal.getAttribute('data-bb-mode') === 'warning') {
            var mv = openModal.querySelector('.bb-cutoff-modal-clock-value');
            if (mv) mv.textContent = clock;
            openModal.classList.toggle('is-elevated', bbCutOffTier(secondsLeft) !== 'is-urgent');
        }
    }

    /*  "yesterday" reads better than "1 day ago", and both read better than a date the
        customer can already see is wrong. Beyond a week nobody counts in days, so it
        falls back to the plain sentence — {days} resolving to nothing leaves the
        placeholder visible, which is why the copy is chosen by reason rather than
        patched afterwards. */
    function daysAgoPhrase(n) {
        if (n === 1) return 'yesterday';
        if (n > 1 && n < 8) return n + ' days ago';
        if (n >= 8) return 'over a week ago';
        return '';
    }

    /*  ── #193: THE MODAL NOW ANSWERS TWO QUESTIONS ──────────────────────────

        It was only ever the consequence of a booking that had already gone stale.
        It is now also the answer to the pill, which is the reversal the whole design
        turns on: the pill poses the question in thirty pixels and the modal answers
        it properly, so the pill does not have to explain itself.

        `warning` is the pill's mode. Two things differ from the stale case:

          1. THE ONCE-PER-PAGE GUARD IS BYPASSED. That guard exists so a modal the
             customer has answered does not reappear over them. A press is the
             customer ASKING for it, and a button that does nothing the second time
             reads as broken.
          2. THE DATES ARE NOT CLEARED by the primary button. In the stale case the
             dates are gone and the button's job is to replace them. Here they are
             still good — clearing them would destroy a valid booking to answer a
             question about it. The mode is written onto the element so the handler
             can tell, rather than being inferred.                                  */
    function showCutOffModal(locationData, verdict, warning) {
        var el = document.querySelector('.bb-cutoff-modal');
        if (!el) return;
        /*  359: the closed box is not once-per-page any more. While the dates do not
            work it is the only thing on offer; the guard re-runs every second and only
            skips if it is ALREADY open, so it cannot be closed and cannot be outrun by
            changing page. */
        if (!warning && !el.classList.contains('hidden') && el.getAttribute('data-bb-mode') !== 'warning') return;
        el.setAttribute('data-bb-mode', warning ? 'warning' : 'stale');

        hideCutOffPill();

        /*  ── TWO DIFFERENT PROBLEMS NEED TWO DIFFERENT SENTENCES — 11-09-2026 ────

            The first cut of this used one body for every failure, and testing the
            overnight case showed why that does not work: a customer returning the next
            morning was told "we're closed for pick-ups today, same-day pick-ups closed
            at 3pm", which is about today and says nothing about the date they actually
            chose. Their dates are not cut off, they have simply gone.

            So the title AND the body are chosen by reason. 'past' gets its own pair,
            with how long ago it was — see daysAgoPhrase above.

            'closed' falls in with 'past': a pick-up day the location is shut on is not
            a cut-off either, and the same "pick some new dates" answer applies. */
        /*  360 (Ben, 11-10-2026, screenshot): a CLOSED pick-up day was given the past-
            date sentence, "You had pick-up set for {days}", with nothing to fill {days}.
            A closed day is not in the past. It now has its own sentence. */
        var isClosed = !warning && verdict && verdict.reason === 'closed';
        var isPast = !warning && verdict && verdict.reason === 'past';
        var closedVals = (function () {
            var d = window.bookingDates && window.bookingDates.start;
            var wd = '';
            try { wd = new Date(String(window.bbIsoDay ? window.bbIsoDay(d) : d).slice(0, 10) + 'T12:00:00').toLocaleDateString('en-AU', { weekday: 'long' }); } catch (e) {}
            return { weekday: wd, location: (locationData && locationData.name) || '' };
        })();
        var cutOffAt = (verdict && verdict.cutOffAt) ||
            (typeof window.cutOffLabel === 'function'
                ? window.cutOffLabel(locationData, window.bookingBarConfig?.storeTimeZone) : '');

        /*  EVERY FALLBACK HERE IS THE REAL SENTENCE, NOT AN EMPTY STRING — 12-09-2026.

            The first cut passed '' as this fallback and guarded on `if (pastTitle)`, so
            when the setting did not resolve the guard failed and the CUT-OFF title was
            left in place: a customer saw "We're closed for pick-ups today" above a body
            that said their dates were yesterday. The body escaped the same fate only
            because it happened to carry a real fallback.

            A theme setting can be absent for ordinary reasons — added to the schema but
            not yet saved, or a section instance that predates it — so an empty fallback
            is not a safe default, it is a silent one. Both strings are now duplicated
            here in full, and must be kept in step with the schema defaults in
            sections/booking-bar.liquid. */
        var titleEl = el.querySelector('.bb-cutoff-modal-title');
        if (titleEl) {
            titleEl.textContent = warning
                ? fillTemplate(cutOffCopy('cutOffWarnTitle', 'Same-day bookings close at {time}'),
                    { time: cutOffAt })
                : (isClosed
                    ? fillTemplate(cutOffCopy('cutOffClosedTitle', "We're closed on {weekday}s"), closedVals)
                    : isPast
                    ? cutOffCopy('cutOffPastTitle', 'Oops! Your dates are no longer available')
                    : cutOffCopy('cutOffModalTitle', "We're closed for pick-ups today, but you still have options"));
        }

        var bodyEl = el.querySelector('.bb-cutoff-modal-body');
        if (bodyEl) {
            var tpl = warning
                ? cutOffCopy('cutOffWarnNote', 'Finish before then and you can have the gear today, by pick-up or delivery. After the cut-off the earliest we can get it to you is tomorrow morning — your gear stays in your booking either way, and nothing is lost.')
                : (isClosed
                    ? cutOffCopy('cutOffClosedBody', "{location} isn't open on {weekday}s, so you'll need to pick new dates. Your gear is still in your booking.")
                    : isPast
                    ? cutOffCopy('cutOffPastBody', "Oops! Your dates are no longer available. You had pick-up set for {days} — unless you're a time traveller, you'll need to pick some new dates.")
                    : cutOffCopy('cutOffModalBody', 'Same-day pick-ups closed at {time}.'));
            bodyEl.textContent = fillTemplate(tpl, {
                time: cutOffAt,
                days: daysAgoPhrase((verdict && verdict.daysAgo) || 0),
                weekday: closedVals.weekday,
                location: closedVals.location
            });
        }

        /* The call button is hidden rather than shown dead when the location has no
           number. An offer to call that cannot be acted on is worse than no offer —
           and see the note on the `phone` field in booking-bar.liquid: the key was
           being guessed, so a blank here is a real possibility. */
        /*  363 — THE CUT-OFF BOX, REDESIGNED (Ben, 11-10-2026: Same-Day Cut-off Header
            Design turn 3, "3a with 3b's button options"). A red status band names the
            time; the headline and body are Ben's copy; one primary button and a quiet
            call link. Past and closed-day boxes keep the earlier layout. */
        var isCut = !warning && !isPast && !isClosed;
        var card = el.querySelector('.bb-cutoff-modal-card');
        if (card) card.classList.toggle('is-cut', !!isCut);
        var band = el.querySelector('.bb-cutoff-modal-band');
        if (band) {
            band.classList.toggle('hidden', !isCut);
            var bt = band.querySelector('.bb-cutoff-modal-band-text');
            if (bt && isCut) bt.textContent = cutOffAt
                ? fillTemplate(cutOffCopy('cutOffV2Band', 'Same-day pickups closed at {time}'), { time: cutOffAt })
                : cutOffCopy('cutOffV2BandNoTime', 'Same-day pickups have closed');
        }
        if (isCut) {
            if (titleEl) titleEl.textContent = cutOffCopy('cutOffV2Title', 'Pickups for today have closed');
            if (bodyEl) bodyEl.textContent = cutOffCopy('cutOffV2Body', "Choose new dates or give us a call and we'll see if we can still squeeze you in today.");
            var rp = el.querySelector('.bb-cutoff-modal-repick:not(.bb-cutoff-modal-ok)');
            if (rp) rp.textContent = cutOffCopy('cutOffV2Button', 'Choose new dates');
        }

        var callEl = el.querySelector('.bb-cutoff-modal-call');
        var phone = locationData && locationData.phone;
        if (callEl) {
            if (phone) {
                callEl.textContent = fillTemplate(
                    isCut ? cutOffCopy('cutOffV2Call', 'Need it today? Call {phone}') : cutOffCopy('cutOffModalCall', 'Call us on {phone}'), { phone: phone });
                callEl.setAttribute('href', 'tel:' + String(phone).replace(/[^0-9+]/g, ''));
                callEl.classList.remove('hidden');
            } else {
                callEl.classList.add('hidden');
            }
        }

        /*  The clock row, and the tier the icon follows. Only in warning mode: with
            the cut-off already passed there is no time left to put in it, and an
            empty box that matches a picture is the thing that looks delivered. */
        var clockRow = el.querySelector('.bb-cutoff-modal-clock');
        var left = warning && typeof window.secondsToCutOff === 'function'
            ? window.secondsToCutOff(locationData, window.bookingBarConfig?.storeTimeZone)
            : null;
        if (clockRow) {
            if (warning && left !== null && left > 0) {
                var cv = clockRow.querySelector('.bb-cutoff-modal-clock-value');
                var cm = clockRow.querySelector('.bb-cutoff-modal-clock-meta');
                if (cv) cv.textContent = bbCutOffClock(left);
                if (cm) cm.textContent = (locationData &&
                    (locationData.suburb || locationData.name)) || '';
                clockRow.classList.remove('hidden');
            } else {
                clockRow.classList.add('hidden');
            }
        }
        el.classList.toggle('is-elevated',
            warning && left !== null && bbCutOffTier(left) !== 'is-urgent');

        /*  358 (Ben, 11-10-2026, item 3 F1): the warning box is only a warning. One
            button, "Got it!", which closes it; no change-dates, no call. The closed
            ("stale") box keeps "Change dates" and "Call us". */
        var okBtn = el.querySelector('.bb-cutoff-modal-ok');
        var repickBtn = el.querySelector('.bb-cutoff-modal-repick:not(.bb-cutoff-modal-ok)');
        if (okBtn) okBtn.classList.toggle('hidden', !warning);
        if (repickBtn) repickBtn.classList.toggle('hidden', !!warning);
        if (callEl && warning) callEl.classList.add('hidden');

        el.classList.remove('hidden');
        var focusBtn = warning ? okBtn : repickBtn;
        if (focusBtn) focusBtn.focus();
    }

    function clearBookingDates() {
        window.bookingDates = { start: null, end: null };
        window.bbCommittedDates = null;

        /* The date attributes go, the location stays. They are independent facts, and
           the customer has not changed their mind about where they are collecting from
           — syncBarFromCart() below restores a location without dates on purpose.

           An empty string is how Shopify removes an attribute. `Charged nights` goes
           with them: a night count for dates that no longer exist is the stale-value
           class of bug this project has spent two days removing. */
        /*  dev-build 211 — kept as window.bbClearWrite so the branch save can wait for
            it. Fired together, the two writes raced and the cart could end up with the
            branch and no dates, or the old dates (Ben's test, 26-09-2026).          */
        window.bbClearWrite = fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                attributes: {
                    '_pick_up_iso': '', '_return_iso': '',
                    'Pick up': '', 'Pick up time': '',
                    'Return': '', 'Return time': '',
                    'Charged nights': ''
                }
            })
        }).catch(function () {});

        /*  ── THE CART MUST BE TOLD, OR IT WILL LET THEM CHECK OUT — 11-09-2026 ────

            Found in testing: clear the dates from the cart page, decline to pick new
            ones, and checkout stayed available. The dates were genuinely gone from the
            cart attributes, so this was not a write failure.

            It is the #72 fault again. `updateCheckoutValidation()` tests
            `!!window.pbCartBookings?.pickUpIso`, and that global is published by an
            inline <script> inside the pb-cart section — page-load state that nothing
            else updates. The attributes had changed; the global had not. So the cart
            still believed a booking existed and enabled the button.

            Two things, in this order:

              1. Patch the global in memory. Whoever changes the cart is responsible for
                 patching it — the same rule the date handler in pb-cart.js already
                 follows, and the reason that file carries the long note about scripts
                 inserted through innerHTML not running.

              2. Dispatch the events the cart already listens for. `bookingbar:changed`
                 re-runs updateCheckoutValidation (pb-cart.js:199), which now reads the
                 patched global and un-ticks the dates checklist. `pbcart:updated` runs
                 pbRedrawFromState (:427) so the dates visibly disappear from the collect
                 box and the header rather than sitting there looking valid.

            No reload, deliberately: the customer has just been sent to the calendar and
            a reload would close the panel under them. */
        if (window.pbCartBookings) {
            window.pbCartBookings.pickUpIso = '';
            window.pbCartBookings.returnIso = '';
            window.pbCartBookings.chargedNights = 0;
        }
        document.dispatchEvent(new CustomEvent('bookingbar:changed', { detail: { cleared: true } }));
        document.dispatchEvent(new CustomEvent('pbcart:updated'));

        if (typeof window.renderCalendar === 'function') window.renderCalendar();
        if (typeof window.updateCalendarSelection === 'function') window.updateCalendarSelection();

        /*  Put the bar's own display back to its no-dates state. These are the exact
            elements applyBookingToBar() writes when it RESTORES a booking (`:113` and
            `updateTopBarTitle` at `:164`), reversed — so the two cannot disagree about
            what "no dates" looks like.

            An earlier draft of this reset a `.bb-top-left-title` element. No such class
            exists anywhere in the theme; the date text is `.bb-hire-dates` and the
            confirmed sentence is `.bb-top-right-title`. Caught in audit. Query for the
            classes the markup actually has, not the ones the names suggest. */
        var hireDatesEl = document.querySelector('.bb-hire-dates');
        if (hireDatesEl) {
            hireDatesEl.textContent = window.bookingBarConfig?.emptyDatesText || '';
            hireDatesEl.classList.remove('active');
        }
        updateSubLine(null, null, null);
        /* 581: hidden title removed */
        $('.bb-top-right-btn').removeClass('active');
        $('.bb-panel-footer-bottom-btn').removeClass('active');
    }

    /*  #139 — this only ever explained a cut-off, because a cut-off was the only way
    dates got cleared on a switch. A closed day is now another way, and "the 1pm
    cut-off has passed" would be a false explanation for it.

    verdict is appended so the two existing arguments keep their meaning and the
    callers that pass only those keep working. */
function showClearedNoteV2(locationData, cutOffAt, verdict) {
    if (verdict && verdict.reason === 'closed') {
        var which = verdict.closedOn === 'end' ? 'return' : 'pick-up';
        var name = (locationData && (locationData.suburb || locationData.name)) || 'this branch';
        var note = document.querySelector('.bb-cleared-note');
        if (note) {
            var body = note.querySelector('.bb-cleared-note-text') || note;
            body.textContent = 'Your dates were cleared because ' + name +
                ' is closed on your ' + which + ' day. Pick dates that work for this branch.';
            note.classList.remove('hidden');
        }
        return;
    }
    return showClearedNote(locationData, cutOffAt);
}

function showClearedNote(locationData, cutOffAt) {
        var el = document.querySelector('.bb-cleared-note');
        if (!el) return;
        var vals = { location: (locationData && locationData.name) || '', time: cutOffAt || '' };
        var t1 = el.querySelector('.bb-cleared-note-title');
        var t2 = el.querySelector('.bb-cleared-note-text');
        /*  Real fallbacks, for the reason given in showCutOffModal — these two were the
            last of the empty-string ones, and they would have failed the same way: the
            note would have opened with two blank lines in it rather than not opening.
            Kept in step with the schema defaults in sections/booking-bar.liquid. */
        if (t1) t1.textContent = fillTemplate(
            cutOffCopy('clearedTitle', 'Unfortunately {location} is closed for pickups today.'), vals);
        if (t2) t2.textContent = fillTemplate(
            cutOffCopy('clearedText', 'Same-day pickups closed at {time}. Your dates have been cleared - pick again below.'), vals);
        el.classList.remove('hidden');
    }

    function hideClearedNote() {
        var el = document.querySelector('.bb-cleared-note');
        if (el) el.classList.add('hidden');
    }

    /* The whole guard, in one pass. Called on page load, after a location switch, and
       on every tick. `onSwitch` picks which remedy applies — see the block comment. */
    /*  360 — TEST MODE. A same-day cut-off can only be tested on a trading day, near
        closing. Add ?cutoff_test=38 to any URL to act as if the booking is for today
        with 38 minutes to go; ?cutoff_test=closed to act as if the cut-off has passed;
        ?cutoff_test=off to stop. It lasts for this browser tab only (sessionStorage).
        Nothing is written to the cart or the store; customers never carry it. */
    function bbCutOffTest() {
        /*  362 (Ben, 11-10-2026: "can anyone typing this into the URL replicate this?"):
            only on a theme that is NOT the published one, i.e. the theme preview and
            the editor. On the live store the switch is ignored. */
        try {
            var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
            if (role === 'main') { sessionStorage.removeItem('bbCutOffTest'); return null; }
        } catch (e) { return null; }
        try {
            var q = new URLSearchParams(location.search).get('cutoff_test');
            if (q === 'off') sessionStorage.removeItem('bbCutOffTest');
            else if (q) sessionStorage.setItem('bbCutOffTest', q);
            var v = sessionStorage.getItem('bbCutOffTest');
            if (!v) return null;
            if (v === 'closed') return { closed: true };
            var m = parseFloat(v);
            return isFinite(m) ? { secs: Math.max(1, Math.round(m * 60)) } : null;
        } catch (e) { return null; }
    }
    var bbTestStart = null;

    /*  363 — AUTO-CLEAR AT THE CUT-OFF (Ben, 11-10-2026). The moment same-day
        pick-ups close, the dates are cleared from the bar and the cart, so nothing can
        slip through to checkout. What happened is remembered in localStorage, so the
        box keeps showing on every page, reload and back/forward until new dates are
        chosen. Past and closed-day dates are unchanged: they keep their own box. */
    var BB_CUT_KEY = 'bbCutOffCleared';
    function bbTodayIso() { return typeof window.civilDate === 'function' ? window.civilDate(new Date()).ymd : ''; }
    function bbCutCleared() {
        try {
            var f = JSON.parse(localStorage.getItem(BB_CUT_KEY) || 'null');
            if (!f) return null;
            if (f.day !== bbTodayIso()) { localStorage.removeItem(BB_CUT_KEY); return null; }
            return f;
        } catch (e) { return null; }
    }
    function bbCutClearedForget() { try { localStorage.removeItem(BB_CUT_KEY); } catch (e) {} bbTestStart = null; }
    window.bbCutClearedForget = bbCutClearedForget;
    function bbCutOffPassed(locationData, verdict) {
        try { localStorage.setItem(BB_CUT_KEY, JSON.stringify({ day: bbTodayIso(), cutOffAt: (verdict && verdict.cutOffAt) || '' })); } catch (e) {}
        hideCutOffPill();
        clearBookingDates();
        showCutOffModal(locationData, verdict);
    }
    document.addEventListener('bookingbar:changed', function (ev) {
        if (ev && ev.detail && ev.detail.startDate) bbCutClearedForget();
    });

    function runCutOffGuard(onSwitch) {
        var locationData = activeLocationData();
        var start = window.bookingDates && window.bookingDates.start;

        var cleared = bbCutCleared();
        if (cleared && !start && locationData) {
            showCutOffModal(locationData, { ok: false, reason: 'cutoff', cutOffAt: cleared.cutOffAt });
            return;
        }

        var T = bbCutOffTest();
        if (T && start && locationData) {
            var cutAt = typeof window.cutOffLabel === 'function' ? window.cutOffLabel(locationData, window.bookingBarConfig?.storeTimeZone) : '';
            if (!cutAt) cutAt = '3pm';
            if (T.closed) { bbCutOffPassed(locationData, { ok: false, reason: 'cutoff', cutOffAt: cutAt }); return; }
            if (bbTestStart === null) bbTestStart = Date.now();
            var tl = T.secs - Math.floor((Date.now() - bbTestStart) / 1000);
            if (tl > 0) {
                var cm = document.querySelector('.bb-cutoff-modal');
                if (cm && cm.getAttribute('data-bb-mode') !== 'warning') cm.classList.add('hidden');
                showCutOffPill(tl, locationData);
            } else { bbCutOffPassed(locationData, { ok: false, reason: 'cutoff', cutOffAt: cutAt }); }
            return;
        }

        if (!start || !locationData || typeof window.validateBookingDates !== 'function') {
            hideCutOffPill();
            return;
        }

        /*  #139 — the return day is passed now. It never was, so a closed return day
            survived a branch switch. See the block comment on validateBookingDates. */
        var end = window.bookingDates && window.bookingDates.end;
        var verdict = window.validateBookingDates(
            start, locationData, window.bookingBarConfig?.storeTimeZone, end);

        if (!verdict.ok) {
            hideCutOffPill();
            if (onSwitch) {
                clearBookingDates();
                showClearedNoteV2(locationData, verdict.cutOffAt, verdict);
            } else if (verdict.reason !== 'past' && verdict.reason !== 'closed') {
                bbCutOffPassed(locationData, verdict);
            } else {
                showCutOffModal(locationData, verdict);
            }
            return;
        }

        /* Still bookable. Warn only inside the window, and only for TODAY — a booking
           for next Tuesday is not affected by today's cut-off. */
        var iso = typeof window.civilDate === 'function' ? window.civilDate(start).ymd : String(start).slice(0, 10);
        var left = typeof window.secondsToCutOff === 'function'
            ? window.secondsToCutOff(locationData, window.bookingBarConfig?.storeTimeZone)
            : null;
        var todayIso = typeof window.civilDate === 'function'
            ? window.civilDate(new Date()).ymd : '';
        var warnWindow = (window.bookingBarConfig?.cutOffWarnMinutes || 15) * 60;

        if (iso === todayIso && left !== null && left > 0 && left <= warnWindow) {
            showCutOffPill(left, locationData);
        } else {
            hideCutOffPill();
        }
    }

    function startCutOffTimer() {
        if (cutOffTimer) return;
        /* One second, because the countdown shows seconds. It costs an Intl format per
           tick, which is cheap, and it stops only when the guard has nothing to say. */
        cutOffTimer = setInterval(function () { runCutOffGuard(false); }, 1000);
    }

    function initCutOffGuard() {
        /*  PRESSING THE PILL OPENS THE MODAL. This is the reversal the design turns
            on. The dismiss and expand handlers that stood here are gone with the
            warning they controlled — see the note above hideCutOffPill. */
        var hit = document.querySelector('.bb-cutoff-pill-hit');
        if (hit) hit.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var locationData = activeLocationData();
            if (!locationData) return;
            showCutOffModal(locationData, null, true);
        });

        var modal = document.querySelector('.bb-cutoff-modal');
        if (modal) {
            /*  358: closing the warning box. "Got it!", Escape and a tap outside the card
                all close it, in warning mode only. The closed box still needs an
                answer (new dates or a call), so it does not close this way. */
            var closeWarning = function () {
                if (modal.getAttribute('data-bb-mode') === 'warning') modal.classList.add('hidden');
            };
            var okBtn = modal.querySelector('.bb-cutoff-modal-ok');
            if (okBtn) okBtn.addEventListener('click', closeWarning);
            modal.addEventListener('click', function (ev) { if (ev.target === modal) closeWarning(); });
            document.addEventListener('keydown', function (ev) {
                if (ev.key === 'Escape' && !modal.classList.contains('hidden')) closeWarning();
            });
            var repick = modal.querySelector('.bb-cutoff-modal-repick:not(.bb-cutoff-modal-ok)');
            if (repick) repick.addEventListener('click', function () {
                modal.classList.add('hidden');
                /*  Only the stale case clears. In warning mode the dates are still
                    good and the customer pressed a button to ASK about them — see
                    the note above showCutOffModal. */
                if (modal.getAttribute('data-bb-mode') !== 'warning') { bbCutClearedForget(); clearBookingDates(); }
                /* Straight into the panel: the customer has been told the dates are
                   gone, so the next thing they need is the calendar, not the page they
                   were on. This is what makes the gear-but-no-dates state (6c) reachable
                   and why the cart page has to render it. */
                var panel = document.querySelector('.bb-panel');
                if (panel) panel.classList.remove('hidden');
                if (typeof window.renderCalendar === 'function') window.renderCalendar();
            });
        }

        startCutOffTimer();
        runCutOffGuard(false);
    }

    async function syncBarFromCart() {
        if (window.isSyncingFromCart) return;

        const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
        if (!cart) return;

        const attrs    = cart.attributes || {};
        const start    = attrs['_pick_up_iso'];
        const end      = attrs['_return_iso'];
        const location = attrs['Location'];

        /* Restore the LOCATION even when the dates are missing.

           This used to be `if (!start || !end || !location) return;` — all or nothing.
           A cart that knew its location but had no dates yet restored neither, so the
           three calendar functions that read .bb-panel-location.active resolved to
           nothing and the customer had to pick a location they had already picked.

           Location and dates are independent facts. Restore whatever is known. */
        if (!location) return;

        if (!start || !end) {
            const waitForLocationOnly = setInterval(() => {
                if (!window.locationMetaobjects) return;
                clearInterval(waitForLocationOnly);

                const handle = locationHandleFromName(location);
                if (handle) applyLocationSelection(handle);
            }, 50);
            return;
        }

        const waitForLocations = setInterval(() => {
            if (!window.locationMetaobjects) return;
            clearInterval(waitForLocations);

            const handle = locationHandleFromName(location);
            if (!handle) return;
            const match = window.locationMetaobjects[handle];

            /* Same routine the click handler uses. Without this the restored booking
               had a location visually selected but window.selectedLocation undefined,
               so the calendar greyed no closed days at all. */
            applyLocationSelection(handle);

            const locationGid = String(match.gid).startsWith('gid://')
                ? match.gid
                : `gid://shopify/Metaobject/${match.gid}`;

            document.dispatchEvent(new CustomEvent('bookingbar:changed', {
                detail: {
                    locationGid,
                    startDate: start,
                    endDate:   end,
                    fromCart:  true
                }
            }));

            if (typeof window.updateCalendarSelection === 'function') {
                window.bookingDates = { start, end };
                window.updateCalendarSelection();
            }

            if (typeof window.updateTopBarTitle === 'function') {
                window.updateTopBarTitle(start, end, match);
            }

            const editBtn = document.querySelector('.bb-top-right-btn');
            if (editBtn) editBtn.classList.add('active');

        }, 100);
    }

    /* ── Everything that should open the panel ──────────────────────────────────
       Previously only .bb-top-right-btn ("Check availability") opened it. The two
       fields beside it looked like controls and did nothing, which reads as broken
       rather than as decorative — a customer taps "Hire dates" precisely because they
       want to set hire dates.

       Delegated from document so it also catches the product card's CTA, which is
       rendered by a different section and may mount after this runs. */
    document.addEventListener('click', function (ev) {
        /*  dev-build 331: the whole header pill opens the panel, not just its
            calendar button. The countdown pill sits inside it and opens the cut-off
            modal instead, so a click on that is left to its own handler. */
        const trigger = ev.target.closest(
            '.bb-top-btn, .bb-top-mobile, .bb-sub-edit, .mm-pill-slot .bb-sub, .pp-booking-card-btn.is-standby, .pp-booking-card-edit-btn'
        );
        if (!trigger || ev.target.closest('.bb-cutoff-pill-hit')) return;

        ev.preventDefault();

        const panel = document.querySelector('.bb-panel');
        if (!panel) return;

        panel.classList.remove('hidden');
        document.body.classList.add('bb-panel-open');
        window.bbOpenSnapshot = null;
        if (window.bbTakeSnapshot) window.bbTakeSnapshot();
        if (typeof window.bbCalendarToSelection === 'function') window.bbCalendarToSelection();   /* 576 */

        /* If the customer tapped "Hire dates" and a location is already chosen, they
           want the calendar, not the location list. Nothing to re-pick. */
        if (trigger.classList.contains('bb-top-btn')) {
            const wantsDates = !!trigger.querySelector('.bb-hire-dates');
            const hasLocation = !!document.querySelector('.bb-panel-location.active');
            if (wantsDates && hasLocation && typeof window.renderCalendar === 'function') {
                window.renderCalendar();
            }
        }
    });

    /* ── Sticky, everywhere except the cart ─────────────────────────────────────
       Applied to the section wrapper rather than the inner .booking-bar, because
       position: sticky resolves against the nearest scrolling ancestor — on the inner
       div it would stick inside a box the same height as itself and never move.

       Excluded on /cart because the cart page has its own booking surface; a second
       one pinned over it is noise.

       z-index 50 sits above page content. If it ever collides with the header, that is
       the number to change, in one place. */
    /*  dev-build 286 (Ben 04-10-2026): not on product pages either. The booking card's
        top band edits the booking there (284), and on phones the bottom drawer carries
        it (286), so a pinned bar would be a second booking control. Same exclusion as
        the cart: the bar stays at the top of the page and scrolls away. */
    /*  dev-build 338 (Ben, 09-10-2026): the cart behaves like every other page. The
        booking is in the header pill, and the bar shows on the page only when no dates
        are set (334, .bb-pinned). The /cart exclusion above is superseded; the product
        page exclusion (286) stands. */
    /*  dev-build 345 (Ben, 10-10-2026): "product pages for desktop and mobile should
        continue to feature the booking bar in the header." The 286 exclusion is
        superseded: product pages behave like every other page. The booking card still
        edits the booking; the pill shows it and opens the same panel. */
    {
        const bar = document.querySelector('.booking-bar');
        const section = bar && (bar.closest('.booking-bar-section') || bar.closest('.shopify-section'));

        if (section) {
            section.classList.add('bb-sticky');

            /*  ── dev-build 331: THE CONDENSED FORM MOVES INTO THE HEADER ─────────
                Approved 09-10-2026 (Booking Header - Build Preview.dc.html). In blind
                testing people missed the 30px line under the header and scrolled back
                to the top to change dates, so the booking now lives IN the header as a
                pill with the location and dates.

                The line itself is MOVED, not copied. updateSubLine(), the countdown
                and every other writer find it with document.querySelector('.bb-sub'),
                so they keep working with one element and one owner. A second copy is
                the two-owners bug this project keeps finding.

                The slot is rendered by snippets/header-actions.liquid. No slot (an
                older header) means nothing moves and the old line still works. */
            const rootEl = document.documentElement;
            const pillSlot = document.querySelector('[data-bb-pill-slot]');
            /*  339: booking-bar.liquid may already have moved it on a pinned page. */
            const subLine = section.querySelector('.bb-sub') || (pillSlot && pillSlot.querySelector('.bb-sub:not([data-bb-pill-copy])'));
            if (pillSlot) pillSlot.querySelectorAll('[data-bb-pill-copy]').forEach(n => n.remove());   // 340
            if (pillSlot && subLine) {
                pillSlot.appendChild(subLine);
                section.classList.add('bb-pill-hosted');
                /*  343: the server already printed the right words; this keeps them right
                    for a cart whose dates were never committed through updateSubLine. */
                if (!window.bbSubState) window.bbSubState = { has: bar.classList.contains('bb-is-set'), text: (subLine.querySelector('.bb-sub-dates') || {}).textContent || '' };
                bbWriteTwoLines();
            }

            /*  343 — PHONES AND TABLETS: the pill fills the space between the menu button
                and the bag (approved preview: the W right after the menu, the pill to the
                bag). It was centred and capped, which left a gap after the menu and cut
                the text off. Measured, because the two buttons are theme-sized; the CSS
                carries close fallbacks for the first paint. */
            const narrow = window.matchMedia('(max-width: 1279px)');
            const placePill = () => {
                if (!pillSlot) return;
                if (!narrow.matches) { ['--mm-pill-l', '--mm-pill-r', '--mm-pill-w', '--mm-home-ml'].forEach(p => pillSlot.style.removeProperty(p)); return; }
                const host = pillSlot.offsetParent;
                const tog = document.querySelector('.header .thb-header-mobile-left');
                const bag = document.querySelector('.header .mm-booking');
                if (!host || !tog || !bag) return;
                const h = host.getBoundingClientRect(), t = tog.getBoundingClientRect(), g = bag.getBoundingClientRect();
                if (!t.width || !g.width) return;
                /*  348 (Ben, 10-10-2026): the W is hidden on phones and tablets, and the pill
                    is centred on the screen on every device. 347 positioned the W and pill
                    inside the slot with margins and a width, and the phone laid them out
                    differently from desktop dev tools (measured: pill 105..297 on a 393 screen,
                    centre 201). Now the SLOT itself is placed: its right edge is G before the
                    bag and its left edge is the mirror of that, and the pill fills it. One
                    rule, no margins, no width to fight. */
                const G = 10;
                const vw = document.documentElement.clientWidth;
                const right = g.left - G;
                const left = vw - right;
                pillSlot.style.setProperty('--mm-pill-l', Math.round(left - h.left) + 'px');
                pillSlot.style.setProperty('--mm-pill-r', Math.round(h.right - right) + 'px');
                ['--mm-pill-w', '--mm-home-ml'].forEach(p => pillSlot.style.removeProperty(p));
            };
            placePill();
            window.addEventListener('load', placePill);
            window.addEventListener('resize', placePill);

            /*  332: the logo link narrows from its real width to the W, and a width
                can only animate between two lengths. Measured with the variable
                removed, so it reads the natural width, and only while the pill is
                off, so it never measures the narrowed state. */
            /*  331: the header reads this one class for the pill, the W mark and the
                centring, set from the same decision that condenses the bar. 333: and off
                while the booking panel is open, when the bar under the header is showing
                the booking instead, and the full logo comes back (approved preview). */
            /*  335 — on the homepage the pill waits until the hero's own booking bar has
                gone under the header (Ben). The hero already decides that moment and
                marks it with html.djw-hh-past (djw-home-hero.liquid), so the pill reads
                that one answer rather than measuring the hero a second time. */
            const isHome = !!document.querySelector('[data-djw-hh]');
            const syncPill = () => rootEl.classList.toggle('bb-pill-on',
                (section.classList.contains('bb-condensed') || section.classList.contains('bb-pinned')) &&
                section.classList.contains('bb-pill-hosted') &&
                (!isHome || rootEl.classList.contains('djw-hh-past')) &&
                !rootEl.classList.contains('bb-open'));
            window.bbSyncPill = syncPill;
            if (isHome && typeof MutationObserver === 'function') {
                let pastNow = rootEl.classList.contains('djw-hh-past');
                new MutationObserver(() => {
                    const p = rootEl.classList.contains('djw-hh-past');
                    if (p !== pastNow) { pastNow = p; syncPill(); }
                }).observe(rootEl, { attributes: true, attributeFilter: ['class'] });
            }

            /*  334 — OTHER PAGES: the bar is on the page only until the booking is set
                (approved preview). Not on the homepage, whose hero is its own booking
                surface. "Set" is the server's answer on load (.bb-is-set, from the cart
                attributes, so the first paint is already right) and the live answer
                after any change: a location chosen and both dates in. */
            const applyPinned = (setNow) => {
                const pin = !isHome && section.classList.contains('bb-pill-hosted') && setNow;
                section.classList.toggle('bb-pinned', pin);
                syncPill();
            };
            applyPinned(bar.classList.contains('bb-is-set'));
            document.addEventListener('bookingbar:changed', () => {
                const st = window.bookingDates || {};
                applyPinned(!!(st.start && st.end && document.querySelector('.bb-panel-location.active')));
            });

            const logoLink = document.querySelector('.menu-logo-container > .logolink');
            /*  339: measures the logo IMAGE, not the link, so it works while the link is
                already narrowed (a page that loads in the pill state) and the logo can
                still widen smoothly if the booking is cleared. */
            const measureLogo = () => {
                const img = logoLink && logoLink.querySelector('.logoimg:not(.logoimg--light)');
                if (!img) return;
                const w = Math.round(img.getBoundingClientRect().width);
                if (w > 0) rootEl.style.setProperty('--mm-logo-w', w + 'px');
            };
            measureLogo();
            window.addEventListener('load', measureLogo);
            window.addEventListener('resize', measureLogo);

            /* ── Stick BELOW the header, which is also sticky ────────────────────────
               Sticky itself was never broken — the bar was measured pinning to top: 0
               correctly. The problem is that it was pinning to the SAME place as the
               header, so the two overlapped.

               app.css: .header-section { position: sticky; top: 0; z-index: 50 }

               That rule is unconditional — the header pins on every page whatever the
               merchant's sticky-header setting says; that setting only drives the shadow
               and transparency (.is-sticky). The booking-bar section is a SIBLING of
               .header-section inside #wrapper, so both stuck at 0 with the same z-index.

               Measure .header-section, not the header. An earlier attempt read
               #header / theme-header, which sits INSIDE .header-section and is
               position: relative — so the offset computed to 0 and nothing moved.

               Prefer --header-height, which header.js maintains on every scroll from the
               header's own clientHeight, and fall back to measuring. Do not hard-code:
               custom.css:887 uses a literal top: 95px for the product gallery, which is
               desktop-only and wrong whenever the announcement bar or header style
               changes. */
            const applyStickyOffset = () => {
                let offset = 0;

                const headerSection = document.querySelector('.header-section');
                if (headerSection && getComputedStyle(headerSection).position === 'sticky') {
                    const themeVar = parseFloat(
                        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
                    );
                    offset = Number.isFinite(themeVar) && themeVar > 0
                        ? Math.round(themeVar)
                        : Math.round(headerSection.getBoundingClientRect().height);
                }

                section.style.setProperty('--bb-sticky-top', offset + 'px');
            };

            /*  ── #193: SCROLL AWAY ───────────────────────────────────────────────
                Chosen 21-09-2026 over four mechanisms that collapse the bar.

                THE BAR NO LONGER CHANGES HEIGHT AT ALL. dev-build 176 measured the
                bar's own height, compared the scroll position against it, and
                collapsed — which changed the very height it had just measured. At
                the boundary the page shortened, the browser clamped the scroll
                position, the clamp fired a scroll event, the shorter position read
                as "expand", the page grew back, and it collapsed again, every
                frame. That is what the flapping was.

                Here the card is never hidden and never animated. It scrolls out of
                view at the reader's own speed and passes behind the header, the
                section pins one card-border higher than the header so the line
                lands exactly at the header's edge, and the line fades in. The flow
                height is identical from first paint to last, so there is no reflow,
                no clamp, and nothing for the threshold to chase.

                TWO MEASUREMENTS, AND THEY ARE NOT THE SAME QUESTION:

                  the SENTINEL is a zero-height marker inserted ABOVE the section.
                  Collapsing changes only what is below the bar, so nothing the bar
                  does can move it. Reading the bar's own rect instead is what let
                  the measurement feed back into itself.

                  --bb-edge is the distance from the top of .booking-bar to the
                  card's HARD BOTTOM BORDER — not to the foot of its padding. Those
                  last 18px exist to give the shadow somewhere to fall, and a shadow
                  is not the bar. Measuring to the padding put the transition 18px
                  late and landed the line at the bottom of the shadow.
                  getBoundingClientRect never includes a box-shadow, so the card
                  element's own rect IS the hard border.                        */
            const sentinel = document.createElement('div');
            sentinel.setAttribute('aria-hidden', 'true');
            sentinel.style.cssText = 'height:0;margin:0;padding:0;border:0;';
            section.parentNode.insertBefore(sentinel, section);

            /*  Whichever card is actually rendered at this width. offsetParent is
                null for a display:none element, which is how .bb-desktop-only and
                .bb-mobile-only are switched — so this answers the question the
                media query already decided rather than duplicating its breakpoint.
                A second copy of that breakpoint in JS is the two-owners bug this
                project keeps finding. */
            const visibleCard = () => {
                const d = bar.querySelector('.bb-top');
                const m = bar.querySelector('.bb-top-mobile');
                if (d && d.offsetParent !== null) return d;
                if (m && m.offsetParent !== null) return m;
                return d || m;
            };

            let bbEdge = 0;
            const measureEdge = () => {
                const card = visibleCard();
                if (!card) return;
                const e = Math.round(
                    card.getBoundingClientRect().bottom - bar.getBoundingClientRect().top
                );
                /*  Guarded against a measurement taken before layout settles, and
                    against writing the same value every frame. */
                if (e > 20 && e !== bbEdge) {
                    bbEdge = e;
                    section.style.setProperty('--bb-edge', e + 'px');
                }
            };

            const applyCondense = () => {
                measureEdge();
                if (!bbEdge) return;

                const pin = parseFloat(
                    getComputedStyle(section).getPropertyValue('--bb-sticky-top')
                ) || 0;
                const past = pin - sentinel.getBoundingClientRect().bottom;
                const on = section.classList.contains('bb-condensed');

                /*  The card's last pixel IS the trigger: the instant its border
                    passes behind the menu the line starts coming up, so there is
                    never a frame with neither on screen. That rule beat "they must
                    never overlap" — a gap is a hole in the page, an overlap is at
                    worst a crowded frame.

                    2px of hysteresis, not 90. A trackpad jitters by fractions of a
                    pixel at rest and a zero-width band would re-target the opacity
                    every frame; 2px is the smallest gap noise cannot cross. It can
                    be this small ONLY because nothing here changes height — there
                    is no clamp to out-run. Do not widen it by analogy with a
                    collapsing bar. */
                if (!on && past > bbEdge) section.classList.add('bb-condensed');
                else if (on && past < bbEdge - 2) section.classList.remove('bb-condensed');

                syncPill();
            };

            /*  dev-build 235 (Ben, 28-09-2026): a reload halfway down the page should land
                with the compressed line already in place, not fade it in. The browser puts
                the scroll position back a moment after load, so the first condense happens
                then, not on the customer's own scroll. Transitions stay off (.bb-instant)
                until the customer first touches, scrolls with a wheel or presses a key,
                with a 1.5s fallback; after that the scroll-to-animate fade is as before. */
            section.classList.add('bb-instant');
            rootEl.classList.add('bb-pill-instant');
            const bbAnimateFromNow = () => {
                section.classList.remove('bb-instant');
                rootEl.classList.remove('bb-pill-instant');
                ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(t => window.removeEventListener(t, bbAnimateFromNow, true));
            };
            ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(t => window.addEventListener(t, bbAnimateFromNow, { capture: true, passive: true }));
            setTimeout(bbAnimateFromNow, 1500);

            applyStickyOffset();
            applyCondense();
            window.addEventListener('resize', applyStickyOffset);
            /*  Re-measure on resize BEFORE deciding, because the card is a different
                height at mobile width and --bb-edge drives the pin as well as the
                trigger. */
            window.addEventListener('resize', () => { bbEdge = 0; applyCondense(); });

            /* The header changes height as you scroll — it shrinks once sticky, and an
               announcement bar above it can be dismissed. Re-measure when it does, so the
               bar never overlaps and never leaves a gap. */
            const headerSection = document.querySelector('.header-section');
            if (headerSection && typeof ResizeObserver === 'function') {
                new ResizeObserver(applyStickyOffset).observe(headerSection);
            }
            window.addEventListener('scroll', () => {
                if (applyStickyOffset._q) return;
                applyStickyOffset._q = requestAnimationFrame(() => {
                    applyStickyOffset._q = null;
                    applyStickyOffset();
                    applyCondense();
                });
            }, { passive: true });
        }
    }

    syncBarFromCart();
    /*  520: a tab left open showed the booking it loaded with. Dates changed in another
        tab were only picked up on reload, so adding from the old tab used the old hire
        length. Coming back to a tab now re-reads the booking from the cart first. */
    window.bbSyncFromCart = syncBarFromCart;
    /*  522: the tab-return re-read moved into cart-reconcile.js (catchUp), so the booking,
        the items and the panels update as one pass instead of racing each other. */

    /*  #84 — after syncBarFromCart, because the guard needs window.bookingDates and the
        active location, and both are restored there. syncBarFromCart is async and
        resolves on a setInterval, so the guard's own timer is what actually catches the
        restored booking a moment later — it does not need to be sequenced behind it. */
    initCutOffGuard();

});

/*  dev-build 238 — keep floating widgets under the phone booking sheet (Ben, 28-09-2026).
    The live chat button is added by a third-party script at the top of the page's layer
    order, so no z-index on the sheet can go above it. While the sheet is open on a
    phone, anything fixed on the page with a very high layer (10000+) that is not part
    of the booking bar is hidden, and shown again the moment the sheet closes.

    dev-build 256 (01-10-2026): the chat could stay hidden for good. 238 decided "open"
    from the sheet NOT having a 'hidden' class and only restored when it saw that class
    come back, so any open/close that went another way, a page restored from the
    back/forward cache, or a sheet that started without the class, left the chat hidden.
    Now: "open" means the sheet is actually on screen (rendered and taller than zero),
    it is re-checked on more events, and whenever the sheet is not open EVERY element we
    ever marked is restored, found in the page by its marker rather than from a list in
    memory. So the worst case is now a chat that shows a moment late, never one that
    stays hidden. */
/*  ── dev-build 333: THE PANEL OPENS FROM THE HEADER ─────────────────────────────
    Approved 09-10-2026 (Booking Header - Build Preview.dc.html).

    html.bb-open is derived from the panel's own .hidden class, which every open and
    close path already sets, so there is no second open/close state to keep in step.
    Tablet and desktop only; the phone sheet is unchanged.

    --bb-hbar-top is the bottom of the header right now, measured on open and while
    open, so the bar and the panel sit flush under it at any scroll position.

    The red-day note (bbShowRedNote, booking-calendar.js) is MOVED into the footer.
    It used to sit under the calendar and could be below the bottom of the screen when
    a red day was tapped (Ben, item 1). The footer is always on screen now, and every
    writer finds the note by its class, so moving it keeps one element and one owner. */
document.addEventListener('DOMContentLoaded', function () {
    var panel = document.querySelector('.booking-bar .bb-panel');
    if (!panel) return;
    var root = document.documentElement;
    var hbar = document.querySelector('.booking-bar .bb-hbar');
    var p2b = panel.querySelector('.bb-p2b');

    /*  341: the dim is its own layer so it can fade in and out (booking-bar.css). */
    if (hbar && !document.querySelector('.booking-bar .bb-dim')) {
        var dim = document.createElement('div');
        dim.className = 'bb-dim';
        dim.setAttribute('aria-hidden', 'true');
        hbar.parentNode.insertBefore(dim, hbar.nextSibling);
    }

    /*  343/344 — THE LOCATION IN THE SHEET'S HEAD (Ben, 10-10-2026). The sheet no
        longer has the chosen-location row, so the head says where: "Your booking" over
        "Pick up from Sydney · Change" (Phone Sheet Location Label.dc.html, option A;
        supersedes 343's lone "Change location" link). "Change" reopens the list.
        Phones only; CSS shows the line only while a location is chosen and the list is
        not already open. The name is written by bbWriteTwoLines, the one writer. */
    var top = panel.querySelector('.bb-panel-top');
    var topTitle = top && top.querySelector('.bb-panel-top-title');
    if (topTitle && p2b && !top.querySelector('.bb-panel-top-text')) {
        var wrap = document.createElement('div');
        wrap.className = 'bb-panel-top-text';
        topTitle.parentNode.insertBefore(wrap, topTitle);
        wrap.appendChild(topTitle);
        var line = document.createElement('span');
        line.className = 'bb-panel-top-loc';
        var lbl = panel.querySelector('.bb-panel-location-label');
        line.innerHTML = '<span class="bb-panel-top-loc-text"></span><span class="bb-panel-top-loc-sep" aria-hidden="true">·</span><button type="button" class="bb-panel-change-loc">Change</button>';
        line.setAttribute('data-label', ((lbl && lbl.textContent) || 'Pick up from').trim());
        wrap.appendChild(line);
        line.querySelector('.bb-panel-change-loc').setAttribute('aria-label', 'Change location');
        line.querySelector('.bb-panel-change-loc').addEventListener('click', function () { p2b.classList.add('is-editing'); });
        bbWriteTwoLines();
    }

    var note = panel.querySelector('.bb-panel-content-cap-note');
    var footBottom = panel.querySelector('.bb-p2b-foot .bb-panel-footer-bottom');
    if (note && footBottom) footBottom.parentNode.insertBefore(note, footBottom);

    var wide = window.matchMedia('(min-width: 768px)');
    var place = function () {
        var hs = document.querySelector('.header-section');
        var b = hs ? Math.max(0, Math.round(hs.getBoundingClientRect().bottom)) : 0;
        root.style.setProperty('--bb-hbar-top', b + 'px');
    };
    var sync = function () {
        var open = !!hbar && wide.matches && !panel.classList.contains('hidden');
        if (open) place();
        var was = root.classList.contains('bb-open');
        root.classList.toggle('bb-open', open);
        if (typeof window.bbSyncPill === 'function') window.bbSyncPill();
        if (open && !was && typeof bbRenderPanelState === 'function') bbRenderPanelState();
    };
    if (typeof MutationObserver === 'function') {
        new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', sync);
    window.addEventListener('scroll', function () { if (root.classList.contains('bb-open')) place(); }, { passive: true });
    if (wide.addEventListener) wide.addEventListener('change', sync);
    sync();

    if (hbar && p2b) {
        hbar.querySelector('.bb-hbar-seg--loc').addEventListener('click', function () {
            p2b.classList.add('is-editing');
        });
        hbar.querySelector('.bb-hbar-seg--dates').addEventListener('click', function () {
            if (!panel.querySelector('.bb-panel-location.active')) return;
            p2b.classList.remove('is-editing');
            if (typeof window.renderCalendar === 'function') window.renderCalendar();
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var panel = document.querySelector('.booking-bar .bb-panel');
    if (!panel) return;
    var phone = window.matchMedia('(max-width: 767px)');
    var sheetOpen = function () {
        if (!phone.matches || panel.classList.contains('hidden')) return false;
        var cs = getComputedStyle(panel);
        if (cs.display === 'none' || cs.visibility === 'hidden') return false;
        return panel.getBoundingClientRect().height > 0;
    };
    var restoreAll = function () {
        document.querySelectorAll('[data-bb-hidden]').forEach(function (el) {
            el.style.removeProperty('visibility');
            delete el.dataset.bbHidden;
        });
    };
    var sync = function () {
        if (!sheetOpen()) { restoreAll(); return; }
        document.querySelectorAll('body > *, body > * > *').forEach(function (el) {
            if (el.contains(panel) || el.dataset.bbHidden || /^(SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(el.tagName)) return;
            var cs = getComputedStyle(el);
            var z = parseInt(cs.zIndex, 10);
            if (cs.position === 'fixed' && z >= 10000 && cs.visibility !== 'hidden') {
                el.dataset.bbHidden = '1';
                el.style.setProperty('visibility', 'hidden', 'important');
            }
        });
    };
    var soon = function () { requestAnimationFrame(sync); };
    if (typeof MutationObserver === 'function') {
        new MutationObserver(soon).observe(panel, { attributes: true, attributeFilter: ['class', 'style'] });
        new MutationObserver(soon).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('pageshow', soon);
    window.addEventListener('resize', soon);
    document.addEventListener('visibilitychange', soon);
    if (phone.addEventListener) phone.addEventListener('change', soon);
    soon();
});

/*  349 — THE BAG'S DOT (Ben, 10-10-2026, Cart Indicator Options.dc.html option A).
    On phones and tablets the count is drawn as a dot, shown only when the bag has gear.
    Whatever updates the count's text (drawer, section re-render), this keeps the
    is-empty class in step with it, so the dot can never disagree with the number. */
(function () {
    function sync(el) {
        var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10) || 0;
        el.classList.toggle('is-empty', n === 0);
    }
    function watch() {
        document.querySelectorAll('.mm-booking__count').forEach(function (el) {
            sync(el);
            if (el.__bbDot) return;
            el.__bbDot = true;
            new MutationObserver(function () { sync(el); }).observe(el, { childList: true, characterData: true, subtree: true });
        });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    /*  The header can be re-rendered as a section, which swaps in a new count element. */
    new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
})();

/*  359 — BACK AND FORWARD (Ben, 11-10-2026): "navigating backwards or forwards in the
    browser should raise the same box until dates have been changed." A page restored
    from the browser's back/forward cache keeps its old memory, which may still hold
    dates the customer has since changed elsewhere, or an open box for dates already
    cleared. If the cart's dates no longer match what this page believes, reload it so
    it starts from the truth; the guard then raises the box again if it is still due. */
window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted || !document.querySelector('.booking-bar')) return;
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        var a = (cart && cart.attributes) || {};
        var d = window.bookingDates || {};
        var iso = window.bbIsoDay || function (v) { return String(v || '').slice(0, 10); };
        var mine = iso(d.start) + '|' + iso(d.end);
        var theirs = String(a['_pick_up_iso'] || '') + '|' + String(a['_return_iso'] || '');
        if (mine !== theirs) location.reload();
    }).catch(function () {});
});

/*  364 — NO SCROLLING BEHIND THE CLOSED BOX (Ben, 11-10-2026). While the "closed"
    box is up (any mode but the old warning), the page is pinned where it is: body is
    fixed at the current offset, which also holds on iOS Safari where overflow:hidden
    alone does not stop the page moving. Released, and the scroll position restored,
    the moment the box closes. Watches the box's class, so every path that opens or
    closes it is covered without touching them. */
(function () {
    var modal = null, locked = false, y = 0;
    function lock() {
        if (locked) return;
        locked = true;
        y = window.scrollY || window.pageYOffset || 0;
        var b = document.body.style;
        b.position = 'fixed';
        b.top = (-y) + 'px';
        b.left = '0';
        b.right = '0';
        b.width = '100%';
        document.documentElement.classList.add('bb-cutoff-lock');
    }
    function unlock() {
        if (!locked) return;
        locked = false;
        var b = document.body.style;
        b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
        document.documentElement.classList.remove('bb-cutoff-lock');
        window.scrollTo(0, y);
    }
    function sync() {
        if (!modal) return;
        var open = !modal.classList.contains('hidden') && modal.getAttribute('data-bb-mode') !== 'warning';
        if (open) lock(); else unlock();
    }
    function init() {
        modal = document.querySelector('.bb-cutoff-modal');
        if (!modal) return;
        new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ['class', 'data-bb-mode'] });
        sync();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
